// import React, {
//   useLayoutEffect,
//   useRef,
//   useState,
//   useEffect,
//   useMemo,
// } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import Select from "react-select";
// import { components } from "react-select";
// import APP_CONFIG from "../../config/appConfig";

// // ── Constants ─────────────────────────────────────────────────────────────────

// const MAX_DEFAULT_COMPANIES = 3;
// const MAX_DEFAULT_METRICS = 4;
// // How many options to show before "Show More" inside each filter panel
// const PANEL_SHOW_DEFAULT = 5;

// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: 8 }}
//       />
//       {props.label}
//     </components.Option>
//   );
// };

// const mergeUniqueCompanies = (...lists) => {
//   const map = new Map();
//   lists.flat().forEach((c) => {
//     if (c && !map.has(c.value)) {
//       map.set(c.value, c);
//     }
//   });
//   return Array.from(map.values());
// };

// // ++++++++++++++++++++++++++++++++++++++++++++++
// const buildGroupedMetricOptions = (availableMetrics) => {
//   return Object.entries(APP_CONFIG?.METRIC_GROUPS)
//     .map(([group, metrics]) => {
//       const options = metrics
//         .filter((metric) => availableMetrics.includes(metric))
//         .map((metric) => ({
//           label: formatMetricLabel(metric),
//           value: metric,
//         }));

//       return options.length
//         ? {
//             label: group,
//             options,
//           }
//         : null;
//     })
//     .filter(Boolean);
// };
// const CollapsibleMenuList = (props) => {
//   const { children, selectProps } = props;

//   const { collapsedGroups, setCollapsedGroups } = selectProps;

//   return (
//     <components.MenuList {...props}>
//       {React.Children.map(children, (group) => {
//         if (!group?.props?.data) return group;

//         const label = group.props.data.label;

//         const isCollapsed = collapsedGroups?.includes(label);

//         return (
//           <div>
//             {/* Group Header */}
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();

//                 setCollapsedGroups((prev) =>
//                   isCollapsed
//                     ? prev.filter((g) => g !== label)
//                     : [...prev, label]
//                 );
//               }}
//               style={{
//                 cursor: "pointer",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 padding: "8px 12px",
//                 background: "#f8f9fa",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               {isCollapsed ? "▶" : "▼"} {label}
//             </div>

//             {/* Group Options */}
//             {!isCollapsed && group}
//           </div>
//         );
//       })}
//     </components.MenuList>
//   );
// };
// // ++++++++++++++++++++++++++++++++++++++++++++++

// const BAR_COLORS = [
//   0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
//   0xd35400,
// ];

// const formatMetricLabel = (metric) =>
//   APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

// // ── Helpers ───────────────────────────────────────────────────────────────────

// // const deriveAvailableMetrics = (financialData) => {
// //   if (!financialData?.length) return [];
// //   const metricSet = new Set();
// //   financialData.forEach((company) => {
// //     company.metrics?.forEach((m) => {
// //       if (m.value !== null && m.value !== undefined) metricSet.add(m.metric);
// //     });
// //   });
// //   return Array.from(metricSet);
// // };

// const deriveAvailableMetrics = (financialData) => {
//   if (!financialData?.length) return [];

//   const metricSet = new Set();

//   financialData.forEach((company) => {
//     company.metrics?.forEach((m) => {
//       if (m.metric && m.value !== null && m.value !== undefined) {
//         metricSet.add(m.metric);
//       }
//     });
//   });

//   return Array.from(metricSet);
// };

// /**
//  * Build amCharts data: one row per metric, one field per company.
//  * { metricLabel: "Total Revenue", "CompanyA": 1234, "CompanyB": 5678 }
//  */
// const buildChartData = (financialData, activeCompanies, activeMetrics) => {
//   if (
//     !financialData?.length ||
//     !activeCompanies?.length ||
//     !activeMetrics?.length
//   )
//     return [];

//   return activeMetrics.map((metric) => {
//     const row = { metricLabel: formatMetricLabel(metric) };
//     activeCompanies.forEach((comp) => {
//       const compData = financialData.find(
//         (fd) => fd.vendor_company_id === comp.value
//       );
//       const metricEntry = compData?.metrics?.find((m) => m.metric === metric);
//       // row[comp.label] = metricEntry?.value ?? 0;
//       // row[comp.label] =
//       //   metricEntry?.value != null ? metricEntry.value / 1e9 : 0;
//       row[comp.label] = metricEntry?.value ?? 0;
//     });
//     return row;
//   });
// };

// // ── Component ─────────────────────────────────────────────────────────────────

// /**
//  * GroupedBarChart
//  *
//  * Props from parent (FinancialPerformance):
//  *  - financialData     : array of { vendor_company_id, company_name, metrics[] }
//  *  - competitorOptions : array of { label, value } — master selected competitors
//  *
//  * All filters here are LOCAL — they only affect the bar chart, not the heatmap.
//  */
// const GroupedBarChart = ({ financialData = [], competitorOptions = [] }) => {
//   const chartRef = useRef(null);

//   // ── derive available metrics from fetched data ───────────────────────────
//   const availableMetrics = useMemo(
//     () => deriveAvailableMetrics(financialData),
//     [financialData]
//   );

//   // +++++++++++++++++++++++++++++++++++++
//   const groupedMetricOptions = useMemo(
//     () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
//     [availableMetrics]
//   );
//   // +++++++++++++++++++++++++++++++++++++

//   // ── local filter state ───────────────────────────────────────────────────
//   // Companies shown in bar chart (default: first MAX_DEFAULT_COMPANIES)
//   const [localCompanies, setLocalCompanies] = useState(() =>
//     competitorOptions.slice(0, MAX_DEFAULT_COMPANIES)
//   );
//   //   // Metrics shown in bar chart (default: first MAX_DEFAULT_METRICS)
//   //   const [localMetrics, setLocalMetrics] = useState(() =>
//   //     availableMetrics.slice(0, MAX_DEFAULT_METRICS)
//   //   );
//   //   // Metric draft (Apply/Cancel pattern matching heatmap)
//   //   const [metricDraft, setMetricDraft] = useState(() =>
//   //     availableMetrics.slice(0, MAX_DEFAULT_METRICS)
//   //   );

//   const [localMetrics, setLocalMetrics] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   const [metricDraft, setMetricDraft] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   // Filter panel open/close
//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);
//   const [showMetricFilter, setShowMetricFilter] = useState(false);

//   const [updatingMetrics, setUpdatingMetrics] = useState(false);

//   // Show more/less inside filter panels
//   const [showAllPanelCompanies, setShowAllPanelCompanies] = useState(false);
//   const [showAllPanelMetrics, setShowAllPanelMetrics] = useState(false);

//   // Show more/less for selected company badges below chart filters
//   const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
//     useState(false);

//   const [collapsedGroups, setCollapsedGroups] = useState(
//     Object.keys(APP_CONFIG?.METRIC_GROUPS)
//   );

//   // Sync localCompanies when master competitorOptions changes
//   //   useEffect(() => {
//   //     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   //   }, [competitorOptions]);

//   // useEffect(() => {
//   //     const unique = mergeUniqueCompanies(competitorOptions);
//   //     setLocalCompanies(unique.slice(0, MAX_DEFAULT_COMPANIES));
//   //   }, [competitorOptions]);

//   // const prevRef = useRef(competitorOptions);

//   // useEffect(() => {
//   //   const prev = prevRef.current;

//   //   const added = competitorOptions.filter(
//   //     (c) => !prev.find((p) => p.value === c.value)
//   //   );

//   //   if (added.length) {
//   //     setLocalCompanies((curr) => mergeUniqueCompanies(curr, added));
//   //   }

//   //   // remove if deleted from master
//   //   setLocalCompanies((curr) =>
//   //     curr.filter((c) => competitorOptions.find((opt) => opt.value === c.value))
//   //   );

//   //   prevRef.current = competitorOptions;
//   // }, [competitorOptions]);

//   useEffect(() => {
//     if (!competitorOptions.length) return;
//     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   }, [competitorOptions]);

//   // Sync localMetrics when available metrics change
//   //   useEffect(() => {
//   //     const defaults = availableMetrics.slice(0, MAX_DEFAULT_METRICS);
//   //     setLocalMetrics(defaults);
//   //     setMetricDraft(defaults);
//   //   }, [availableMetrics]);

//   useEffect(() => {
//     const unique = [...new Set(availableMetrics)];
//     const defaults = unique.slice(0, MAX_DEFAULT_METRICS);

//     setLocalMetrics(defaults);
//     setMetricDraft(defaults);
//   }, [availableMetrics]);

//   // ── chart data ───────────────────────────────────────────────────────────
//   const chartData = useMemo(
//     () => buildChartData(financialData, localCompanies, localMetrics),
//     [financialData, localCompanies, localMetrics]
//   );

//   // ── amCharts rendering ───────────────────────────────────────────────────
//   useLayoutEffect(() => {
//     if (!chartData.length || !localCompanies.length) return;

//     let root = am5.Root.new(chartRef.current);
//     root._logo.dispose();
//     root.setThemes([am5themes_Animated.new(root)]);

//     let chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         layout: root.verticalLayout,
//         panX: false,
//         panY: false,

//         paddingTop: 20,
//         paddingBottom: 20,
//         paddingLeft: 20,
//         paddingRight: 20,
//       })
//     );

//     let xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         categoryField: "metricLabel",
//         renderer: am5xy.AxisRendererX.new(root, {
//           cellStartLocation: 0.1,
//           cellEndLocation: 0.9,

//           minGridDistance: 40, // spacing between labels
//         }),
//       })
//     );

//     xAxis.get("renderer").labels.template.setAll({
//       paddingTop: 10,
//       oversizedBehavior: "wrap",
//       maxWidth: 120,
//       textAlign: "center",
//     });

//     xAxis.data.setAll(chartData);

//     chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     // const yAxis = chart.yAxes.getIndex(0);
//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     yAxis.get("renderer").labels.template.setAll({
//       paddingRight: 10,
//     });

//     yAxis.get("renderer").labels.template.adapters.add("text", (text) => {
//       return text ? text + "B" : text;
//     });

//     localCompanies.forEach((comp, idx) => {
//       const color = BAR_COLORS[idx % BAR_COLORS.length];
//       const series = chart.series.push(
//         am5xy.ColumnSeries.new(root, {
//           name: comp.label,
//           xAxis,
//           yAxis,
//           valueYField: comp.label,
//           categoryXField: "metricLabel",
//           fill: am5.color(color),
//           stroke: am5.color(color),
//           clustered: true,
//         })
//       );
//       series.columns.template.setAll({
//         // tooltipText: "{name}: {valueY}",
//         tooltipText: "{name}: {valueY}B",
//         width: am5.percent(60),
//       });
//       series.data.setAll(chartData);
//     });

//     chart.set("cursor", am5xy.XYCursor.new(root, {}));

//     // root.container.children
//     //   .push(
//     //     am5.Legend.new(root, {
//     //       centerX: am5.p50,
//     //       x: am5.p50,
//     //       layout: root.horizontalLayout,
//     //     })
//     //   )
//     //   .data.setAll(chart.series.values);

//     let legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,
//         layout: root.horizontalLayout,

//         paddingTop: 15,
//         paddingBottom: 10,
//       })
//     );

//     legend.labels.template.setAll({
//       paddingLeft: 8,
//       paddingRight: 8,
//     });

//     legend.itemContainers.template.setAll({
//       paddingRight: 15,
//       paddingTop: 5,
//       paddingBottom: 5,
//     });

//     legend.data.setAll(chart.series.values);

//     return () => root.dispose();
//   }, [chartData, localCompanies]);

//   // ── toggle helpers ───────────────────────────────────────────────────────
//   //   const toggleCompany = (comp) => {
//   //     setLocalCompanies((prev) => {
//   //       const exists = prev.find((c) => c.value === comp.value);
//   //       return exists
//   //         ? prev.filter((c) => c.value !== comp.value)
//   //         : [...prev, comp];
//   //     });
//   //   };

//   const toggleCompany = (comp) => {
//     setLocalCompanies((prev) => {
//       const exists = prev.find((c) => c.value === comp.value);
//       if (exists) {
//         return prev.filter((c) => c.value !== comp.value);
//       }
//       return mergeUniqueCompanies(prev, [comp]);
//     });
//   };

//   //   const applyMetricFilter = () => {
//   //     setUpdatingMetrics(true);
//   //     setTimeout(() => {
//   //       setLocalMetrics([...metricDraft]);
//   //       setShowMetricFilter(false);
//   //       setUpdatingMetrics(false);
//   //     }, 500);
//   //   };

//   const applyMetricFilter = () => {
//     setUpdatingMetrics(true);
//     setTimeout(() => {
//       setLocalMetrics([...new Set(metricDraft)]);
//       setShowMetricFilter(false);
//       setUpdatingMetrics(false);
//     }, 500);
//   };

//   // Panel: companies shown inside filter card (show more/less)
//   const panelCompanies = showAllPanelCompanies
//     ? competitorOptions
//     : competitorOptions.slice(0, PANEL_SHOW_DEFAULT);

//   // Panel: metrics shown inside filter card (show more/less)
//   const panelMetrics = showAllPanelMetrics
//     ? availableMetrics
//     : availableMetrics.slice(0, PANEL_SHOW_DEFAULT);

//   // Selected company badges below filter row (show more/less)
//   const visibleSelectedCompanies = showAllSelectedCompanies
//     ? localCompanies
//     : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

//   if (!financialData.length) return null;

//   return (
//     <div className="container mt-4 heatmap_wrapper">
//       <h3 className="mb-3 heatmap_head">Financial Performance - Bar Chart</h3>

//       {/* ── Filter buttons row (matches heatmap button style) ── */}
//       <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
//         <button
//           // className="btn mt-4 ml-3 heatmap_filter_metrics"
//           className="btn mt-4 heatmap_filter_metrics"
//           onClick={() => {
//             setShowCompanyFilter((prev) => !prev);
//             setShowMetricFilter(false);
//           }}
//         >
//           Filter Companies
//         </button>

//         <button
//           className="btn mt-4 ml-3 heatmap_filter_metrics"
//           onClick={() => {
//             setMetricDraft(localMetrics);
//             setShowMetricFilter((prev) => !prev);
//             setShowCompanyFilter(false);
//           }}
//         >
//           Filter Metrics
//         </button>
//       </div>

//       {/* ── Company filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showCompanyFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Companies
//           </label>

//           {/* <div className="d-flex flex-wrap selected_companies_tags"> */}
//           {/* {panelCompanies.map((comp) => {
//               const isSelected = !!localCompanies.find(
//                 (c) => c.value === comp.value
//               );
//               return (
//                 <div
//                   key={comp.value}
//                   className={`badge p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges ${
//                     isSelected ? "badge-primary" : "badge-light"
//                   }`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   {comp.label}
//                   {isSelected && (
//                     <span
//                       className="ml-2"
//                       style={{ fontWeight: "bold" }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         toggleCompany(comp);
//                       }}
//                     >
//                       ×
//                     </span>
//                   )}
//                 </div>
//               );
//             })} */}
//           {/* </div> */}
//           <Select
//             isMulti
//             //   options={competitorOptions}
//             options={mergeUniqueCompanies(competitorOptions)}
//             value={localCompanies}
//             className="font13 search_competitors_select"
//             placeholder="Search companies..."
//             closeMenuOnSelect={false}
//             isClearable={false}
//             backspaceRemovesValue={false}
//             hideSelectedOptions={false}
//             components={{ Option: CheckboxOption }}
//             controlShouldRenderValue={false}
//             onChange={(list) => setLocalCompanies(list || [])}
//           />

//           {/* Show more / Show less inside panel */}
//           {/* {competitorOptions.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelCompanies((prev) => !prev)}
//             >
//               {showAllPanelCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     competitorOptions.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )} */}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowCompanyFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localCompanies.length}
//           </small>
//         </div>
//       )}

//       {/* ── Metric filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showMetricFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Metrics
//           </label>

//           {/* <div className="d-flex flex-wrap selected_companies_tags">
//             {panelMetrics.map((metric) => {
//               const isSelected = metricDraft.includes(metric);
//               return (
//                 <div
//                   key={metric}
//                   className={`badge p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges ${
//                     isSelected ? "badge-primary" : "badge-light"
//                   }`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() =>
//                     setMetricDraft((prev) =>
//                       isSelected
//                         ? prev.filter((m) => m !== metric)
//                         : [...prev, metric]
//                     )
//                   }
//                 >
//                   {formatMetricLabel(metric)}
//                   {isSelected && (
//                     <span
//                       className="ml-2"
//                       style={{ fontWeight: "bold" }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setMetricDraft((prev) =>
//                           prev.filter((m) => m !== metric)
//                         );
//                       }}
//                     >
//                       ×
//                     </span>
//                   )}
//                 </div>
//               );
//             })}
//           </div> */}

//           {/* <Select
//             isMulti
//             closeMenuOnSelect={false}
//             // options={availableMetrics.map((m) => ({
//             //   label: formatMetricLabel(m),
//             //   value: m,
//             // }))}
//             options={groupedMetricOptions}
//             value={availableMetrics
//               .map((m) => ({ label: formatMetricLabel(m), value: m }))
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Group: CollapsibleGroup,
//               GroupHeading: CollapsibleGroupHeading,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           /> */}

//           <Select
//             isMulti
//             className="font13 search_competitors_select"
//             closeMenuOnSelect={false}
//             hideSelectedOptions={false}
//             controlShouldRenderValue={false}
//             options={groupedMetricOptions}
//             value={groupedMetricOptions
//               .flatMap((group) => group.options)
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Option: CheckboxOption,
//               MenuList: CollapsibleMenuList,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           />

//           {/* Show more / Show less inside panel */}
//           {availableMetrics.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelMetrics((prev) => !prev)}
//             >
//               {showAllPanelMetrics
//                 ? "Show Less"
//                 : `Show More (${
//                     availableMetrics.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-primary btn-sm select_heatmap_apply_btn"
//               onClick={applyMetricFilter}
//               disabled={metricDraft.length === 0 || updatingMetrics}
//             >
//               Apply
//             </button>
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowMetricFilter(false)}
//             >
//               Cancel
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {metricDraft.length}
//           </small>
//         </div>
//       )}

//       {updatingMetrics && (
//         <div className="mt-2 text-primary font14">Updating filters...</div>
//       )}

//       {/* ── Active selected company badges ── */}
//       {localCompanies.length > 0 && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Showing Companies
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             {visibleSelectedCompanies.map((comp) => (
//               <div
//                 key={comp.value}
//                 className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
//               >
//                 {comp.label}
//                 <span
//                   className="ml-2"
//                   style={{ cursor: "pointer", fontWeight: "bold" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   ×
//                 </span>
//               </div>
//             ))}
//           </div>

//           {/* Show more / Show less for active badges */}
//           {localCompanies.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
//             >
//               {showAllSelectedCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     localCompanies.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}
//         </div>
//       )}

//       {/* ── Chart ── */}
//       <div ref={chartRef} style={{ width: "100%", height: "350px" }} />
//     </div>
//   );
// };

// export default GroupedBarChart;

// import React, {
//   useLayoutEffect,
//   useRef,
//   useState,
//   useEffect,
//   useMemo,
// } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import Select from "react-select";
// import { components } from "react-select";
// import APP_CONFIG from "../../config/appConfig";

// // ── Constants ─────────────────────────────────────────────────────────────────

// const MAX_DEFAULT_COMPANIES = 3;
// const MAX_DEFAULT_METRICS = 4;
// // How many options to show before "Show More" inside each filter panel
// const PANEL_SHOW_DEFAULT = 5;

// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: 8 }}
//       />
//       {props.label}
//     </components.Option>
//   );
// };

// const mergeUniqueCompanies = (...lists) => {
//   const map = new Map();
//   lists.flat().forEach((c) => {
//     if (c && !map.has(c.value)) {
//       map.set(c.value, c);
//     }
//   });
//   return Array.from(map.values());
// };

// // ++++++++++++++++++++++++++++++++++++++++++++++
// const buildGroupedMetricOptions = (availableMetrics) => {
//   return Object.entries(APP_CONFIG?.METRIC_GROUPS)
//     .map(([group, metrics]) => {
//       const options = metrics
//         .filter((metric) => availableMetrics.includes(metric))
//         .map((metric) => ({
//           label: formatMetricLabel(metric),
//           value: metric,
//         }));

//       return options.length
//         ? {
//             label: group,
//             options,
//           }
//         : null;
//     })
//     .filter(Boolean);
// };
// const CollapsibleMenuList = (props) => {
//   const { children, selectProps } = props;

//   const { collapsedGroups, setCollapsedGroups } = selectProps;

//   return (
//     <components.MenuList {...props}>
//       {React.Children.map(children, (group) => {
//         if (!group?.props?.data) return group;

//         const label = group.props.data.label;

//         const isCollapsed = collapsedGroups?.includes(label);

//         return (
//           <div>
//             {/* Group Header */}
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();

//                 setCollapsedGroups((prev) =>
//                   isCollapsed
//                     ? prev.filter((g) => g !== label)
//                     : [...prev, label]
//                 );
//               }}
//               style={{
//                 cursor: "pointer",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 padding: "8px 12px",
//                 background: "#f8f9fa",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               {isCollapsed ? "▶" : "▼"} {label}
//             </div>

//             {/* Group Options */}
//             {!isCollapsed && group}
//           </div>
//         );
//       })}
//     </components.MenuList>
//   );
// };
// // ++++++++++++++++++++++++++++++++++++++++++++++

// const BAR_COLORS = [
//   0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
//   0xd35400,
// ];

// const formatMetricLabel = (metric) =>
//   APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

// // ── Helpers ───────────────────────────────────────────────────────────────────

// // const deriveAvailableMetrics = (financialData) => {
// //   if (!financialData?.length) return [];
// //   const metricSet = new Set();
// //   financialData.forEach((company) => {
// //     company.metrics?.forEach((m) => {
// //       if (m.value !== null && m.value !== undefined) metricSet.add(m.metric);
// //     });
// //   });
// //   return Array.from(metricSet);
// // };

// const deriveAvailableMetrics = (financialData) => {
//   if (!financialData?.length) return [];

//   const metricSet = new Set();

//   financialData.forEach((company) => {
//     company.metrics?.forEach((m) => {
//       if (m.metric && m.value !== null && m.value !== undefined) {
//         metricSet.add(m.metric);
//       }
//     });
//   });

//   return Array.from(metricSet);
// };

// /**
//  * Build amCharts data: one row per metric, one field per company.
//  * { metricLabel: "Total Revenue", "CompanyA": 1234, "CompanyB": 5678 }
//  */
// const buildChartData = (financialData, activeCompanies, activeMetrics) => {
//   if (
//     !financialData?.length ||
//     !activeCompanies?.length ||
//     !activeMetrics?.length
//   )
//     return [];

//   return activeMetrics.map((metric) => {
//     const row = { metricLabel: formatMetricLabel(metric) };
//     activeCompanies.forEach((comp) => {
//       const compData = financialData.find(
//         (fd) => fd.vendor_company_id === comp.value
//       );
//       const metricEntry = compData?.metrics?.find((m) => m.metric === metric);
//       // row[comp.label] = metricEntry?.value ?? 0;
//       // row[comp.label] =
//       //   metricEntry?.value != null ? metricEntry.value / 1e9 : 0;
//       row[comp.label] = metricEntry?.value ?? 0;
//     });
//     return row;
//   });
// };

// // ── Component ─────────────────────────────────────────────────────────────────

// /**
//  * GroupedBarChart
//  *
//  * Props from parent (FinancialPerformance):
//  *  - financialData     : array of { vendor_company_id, company_name, metrics[] }
//  *  - competitorOptions : array of { label, value } — master selected competitors
//  *
//  * All filters here are LOCAL — they only affect the bar chart, not the heatmap.
//  */
// const GroupedBarChart = ({ financialData = [], competitorOptions = [] }) => {
//   const chartRef = useRef(null);

//   // ── derive available metrics from fetched data ───────────────────────────
//   const availableMetrics = useMemo(
//     () => deriveAvailableMetrics(financialData),
//     [financialData]
//   );

//   // +++++++++++++++++++++++++++++++++++++
//   const groupedMetricOptions = useMemo(
//     () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
//     [availableMetrics]
//   );
//   // +++++++++++++++++++++++++++++++++++++

//   // ── local filter state ───────────────────────────────────────────────────
//   // Companies shown in bar chart (default: first MAX_DEFAULT_COMPANIES)
//   const [localCompanies, setLocalCompanies] = useState(() =>
//     competitorOptions.slice(0, MAX_DEFAULT_COMPANIES)
//   );
//   //   // Metrics shown in bar chart (default: first MAX_DEFAULT_METRICS)
//   //   const [localMetrics, setLocalMetrics] = useState(() =>
//   //     availableMetrics.slice(0, MAX_DEFAULT_METRICS)
//   //   );
//   //   // Metric draft (Apply/Cancel pattern matching heatmap)
//   //   const [metricDraft, setMetricDraft] = useState(() =>
//   //     availableMetrics.slice(0, MAX_DEFAULT_METRICS)
//   //   );

//   const [localMetrics, setLocalMetrics] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   const [metricDraft, setMetricDraft] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   // Filter panel open/close
//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);
//   const [showMetricFilter, setShowMetricFilter] = useState(false);

//   const [updatingMetrics, setUpdatingMetrics] = useState(false);

//   // Show more/less inside filter panels
//   const [showAllPanelCompanies, setShowAllPanelCompanies] = useState(false);
//   const [showAllPanelMetrics, setShowAllPanelMetrics] = useState(false);

//   // Show more/less for selected company badges below chart filters
//   const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
//     useState(false);

//   const [collapsedGroups, setCollapsedGroups] = useState(
//     Object.keys(APP_CONFIG?.METRIC_GROUPS)
//   );

//   // Sync localCompanies when master competitorOptions changes
//   //   useEffect(() => {
//   //     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   //   }, [competitorOptions]);

//   // useEffect(() => {
//   //     const unique = mergeUniqueCompanies(competitorOptions);
//   //     setLocalCompanies(unique.slice(0, MAX_DEFAULT_COMPANIES));
//   //   }, [competitorOptions]);

//   // const prevRef = useRef(competitorOptions);

//   // useEffect(() => {
//   //   const prev = prevRef.current;

//   //   const added = competitorOptions.filter(
//   //     (c) => !prev.find((p) => p.value === c.value)
//   //   );

//   //   if (added.length) {
//   //     setLocalCompanies((curr) => mergeUniqueCompanies(curr, added));
//   //   }

//   //   // remove if deleted from master
//   //   setLocalCompanies((curr) =>
//   //     curr.filter((c) => competitorOptions.find((opt) => opt.value === c.value))
//   //   );

//   //   prevRef.current = competitorOptions;
//   // }, [competitorOptions]);

//   useEffect(() => {
//     if (!competitorOptions.length) return;
//     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   }, [competitorOptions]);

//   // Sync localMetrics when available metrics change
//   //   useEffect(() => {
//   //     const defaults = availableMetrics.slice(0, MAX_DEFAULT_METRICS);
//   //     setLocalMetrics(defaults);
//   //     setMetricDraft(defaults);
//   //   }, [availableMetrics]);

//   useEffect(() => {
//     const unique = [...new Set(availableMetrics)];
//     const defaults = unique.slice(0, MAX_DEFAULT_METRICS);

//     setLocalMetrics(defaults);
//     setMetricDraft(defaults);
//   }, [availableMetrics]);

//   // ── chart data ───────────────────────────────────────────────────────────
//   const chartData = useMemo(
//     () => buildChartData(financialData, localCompanies, localMetrics),
//     [financialData, localCompanies, localMetrics]
//   );

//   // ── amCharts rendering ───────────────────────────────────────────────────
//   // useLayoutEffect(() => {
//   //   if (!chartData.length || !localCompanies.length) return;

//   //   let root = am5.Root.new(chartRef.current);
//   //   root._logo.dispose();
//   //   root.setThemes([am5themes_Animated.new(root)]);

//   //   let chart = root.container.children.push(
//   //     am5xy.XYChart.new(root, {
//   //       layout: root.verticalLayout,
//   //       panX: false,
//   //       panY: false,

//   //       paddingTop: 20,
//   //       paddingBottom: 20,
//   //       paddingLeft: 20,
//   //       paddingRight: 20,
//   //     })
//   //   );

//   //   let xAxis = chart.xAxes.push(
//   //     am5xy.CategoryAxis.new(root, {
//   //       categoryField: "metricLabel",
//   //       renderer: am5xy.AxisRendererX.new(root, {
//   //         cellStartLocation: 0.1,
//   //         cellEndLocation: 0.9,

//   //         minGridDistance: 40, // spacing between labels
//   //       }),
//   //     })
//   //   );

//   //   xAxis.get("renderer").labels.template.setAll({
//   //     paddingTop: 10,
//   //     oversizedBehavior: "wrap",
//   //     maxWidth: 120,
//   //     textAlign: "center",
//   //   });

//   //   xAxis.data.setAll(chartData);

//   //   chart.yAxes.push(
//   //     am5xy.ValueAxis.new(root, {
//   //       renderer: am5xy.AxisRendererY.new(root, {}),
//   //       min: 0,
//   //     })
//   //   );

//   //   // const yAxis = chart.yAxes.getIndex(0);
//   //   const yAxis = chart.yAxes.push(
//   //     am5xy.ValueAxis.new(root, {
//   //       renderer: am5xy.AxisRendererY.new(root, {}),
//   //       min: 0,
//   //     })
//   //   );

//   //   yAxis.get("renderer").labels.template.setAll({
//   //     paddingRight: 10,
//   //   });

//   //   yAxis.get("renderer").labels.template.adapters.add("text", (text) => {
//   //     return text ? text + "B" : text;
//   //   });

//   //   localCompanies.forEach((comp, idx) => {
//   //     const color = BAR_COLORS[idx % BAR_COLORS.length];
//   //     const series = chart.series.push(
//   //       am5xy.ColumnSeries.new(root, {
//   //         name: comp.label,
//   //         xAxis,
//   //         yAxis,
//   //         valueYField: comp.label,
//   //         categoryXField: "metricLabel",
//   //         fill: am5.color(color),
//   //         stroke: am5.color(color),
//   //         clustered: true,
//   //       })
//   //     );
//   //     series.columns.template.setAll({
//   //       // tooltipText: "{name}: {valueY}",
//   //       tooltipText: "{name}: {valueY}B",
//   //       width: am5.percent(60),
//   //     });
//   //     series.data.setAll(chartData);
//   //   });

//   //   chart.set("cursor", am5xy.XYCursor.new(root, {}));

//   //   // root.container.children
//   //   //   .push(
//   //   //     am5.Legend.new(root, {
//   //   //       centerX: am5.p50,
//   //   //       x: am5.p50,
//   //   //       layout: root.horizontalLayout,
//   //   //     })
//   //   //   )
//   //   //   .data.setAll(chart.series.values);

//   //   let legend = chart.children.push(
//   //     am5.Legend.new(root, {
//   //       centerX: am5.p50,
//   //       x: am5.p50,
//   //       layout: root.horizontalLayout,

//   //       paddingTop: 15,
//   //       paddingBottom: 10,
//   //     })
//   //   );

//   //   legend.labels.template.setAll({
//   //     paddingLeft: 8,
//   //     paddingRight: 8,
//   //   });

//   //   legend.itemContainers.template.setAll({
//   //     paddingRight: 15,
//   //     paddingTop: 5,
//   //     paddingBottom: 5,
//   //   });

//   //   legend.data.setAll(chart.series.values);

//   //   return () => root.dispose();
//   // }, [chartData, localCompanies]);

//   useLayoutEffect(() => {
//     if (!chartData.length || !localCompanies.length) return;

//     let root = am5.Root.new(chartRef.current);
//     root._logo.dispose();
//     root.setThemes([am5themes_Animated.new(root)]);

//     // Dynamic width for native horizontal scroll
//     const categoryWidth = 180;

//     const chartWidth = Math.max(
//       chartData.length * categoryWidth,
//       chartRef.current?.offsetWidth || 1200
//     );

//     // ─────────────────────────────────────
//     // Chart
//     // ─────────────────────────────────────
//     let chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         layout: root.verticalLayout,

//         panX: false,
//         panY: false,

//         wheelX: "none",
//         wheelY: "none",

//         paddingTop: 20,
//         paddingBottom: 20,
//         paddingLeft: 10,
//         paddingRight: 20,
//       })
//     );

//     // Native horizontal scroll support
//     chart.plotContainer.set("width", chartWidth);

//     // ─────────────────────────────────────
//     // X Axis
//     // ─────────────────────────────────────
//     // const xRenderer = am5xy.AxisRendererX.new(root, {
//     //   minGridDistance: 60,
//     //   cellStartLocation: 0.15,
//     //   cellEndLocation: 0.85,
//     // });

//     // const xAxis = chart.xAxes.push(
//     //   am5xy.CategoryAxis.new(root, {
//     //     categoryField: "metricLabel",
//     //     renderer: xRenderer,
//     //   })
//     // );

//     // xAxis.data.setAll(chartData);

//     // // Label styles
//     // xRenderer.labels.template.setAll({
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   paddingTop: 10,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",
//     //   tooltipY: 0,
//     // });

//     // // FULL TOOLTIP LABEL
//     // xRenderer.labels.template.setup = (target) => {
//     //   target.set(
//     //     "tooltip",
//     //     am5.Tooltip.new(root, {
//     //       labelText: "{category}",
//     //       pointerOrientation: "up",
//     //     })
//     //   );
//     // };

//     // // Proper truncated label text
//     // xRenderer.labels.template.adapters.add("text", (text) => {
//     //   if (!text) return "";

//     //   return text.length > 16 ? `${text.substring(0, 16)}...` : text;
//     // });

//     // // Full tooltip label
//     // xRenderer.labels.template.adapters.add("tooltipText", (_, target) => {
//     //   return target.dataItem?.dataContext?.metricLabel || "";
//     // });

//     // xAxis.get("tooltip")?.label.setAll({
//     //   oversizedBehavior: "wrap",
//     // });

//     // ─────────────────────────────────────
//     // X Axis
//     // ─────────────────────────────────────
//     const xRenderer = am5xy.AxisRendererX.new(root, {
//       minGridDistance: 60,
//       cellStartLocation: 0.15,
//       cellEndLocation: 0.85,
//     });

//     const xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         categoryField: "metricLabel",
//         renderer: xRenderer,
//       })
//     );

//     xAxis.data.setAll(chartData);

//     // Store original label separately
//     xRenderer.labels.template.setAll({
//       paddingTop: 10,
//       oversizedBehavior: "none",
//       textAlign: "center",
//       interactive: true,
//       cursorOverStyle: "pointer",
//       maxWidth: 120,
//       fontSize: 12,
//     });

//     // Proper truncate with original preservation
//     xRenderer.labels.template.adapters.add("text", (text, target) => {
//       if (!text) return "";

//       // Store full text
//       target.setPrivate("fullText", text);

//       return text.length > 12 ? `${text.slice(0, 12)}...` : text;
//     });

//     // REAL TOOLTIP
//     xRenderer.labels.template.events.on("pointerover", (ev) => {
//       const label = ev.target;

//       const fullText = label.getPrivate("fullText");

//       if (!fullText) return;

//       if (!label.get("tooltip")) {
//         label.set(
//           "tooltip",
//           am5.Tooltip.new(root, {
//             pointerOrientation: "up",
//             labelText: fullText,
//           })
//         );
//       }

//       label.get("tooltip").label.setAll({
//         text: fullText,
//         oversizedBehavior: "wrap",
//         maxWidth: 300,
//       });

//       label.showTooltip();
//     });

//     // Click support
//     xRenderer.labels.template.events.on("click", (ev) => {
//       const fullText = ev.target.getPrivate("fullText");

//       if (fullText) {
//         alert(fullText);
//       }
//     });

//     // ─────────────────────────────────────
//     // Y Axis
//     // ─────────────────────────────────────
//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     yAxis.get("renderer").labels.template.setAll({
//       paddingRight: 10,
//     });

//     // Remove B suffix completely
//     yAxis.get("renderer").labels.template.adapters.add("text", (text) => text);

//     // Axis title
//     yAxis.children.unshift(
//       am5.Label.new(root, {
//         text: "Values in Billions",
//         rotation: -90,
//         y: am5.p50,
//         centerX: am5.p50,
//         fontSize: 13,
//       })
//     );

//     // ─────────────────────────────────────
//     // Series
//     // ─────────────────────────────────────
//     localCompanies.forEach((comp, idx) => {
//       const color = BAR_COLORS[idx % BAR_COLORS.length];

//       const series = chart.series.push(
//         am5xy.ColumnSeries.new(root, {
//           name: comp.label,
//           xAxis,
//           yAxis,
//           valueYField: comp.label,
//           categoryXField: "metricLabel",

//           fill: am5.color(color),
//           stroke: am5.color(color),

//           clustered: true,
//         })
//       );

//       series.columns.template.setAll({
//         width: am5.percent(65),
//         tooltipText: "{name}\n{categoryX}\n{valueY}",
//       });

//       series.data.setAll(chartData);
//     });

//     // ─────────────────────────────────────
//     // Cursor
//     // ─────────────────────────────────────
//     chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         behavior: "none",
//       })
//     );

//     // ─────────────────────────────────────
//     // Legend
//     // ─────────────────────────────────────
//     const legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,
//         width: am5.percent(100),

//         layout: root.horizontalLayout,

//         paddingTop: 15,
//         paddingBottom: 10,
//       })
//     );

//     // FULL LEGEND LABELS
//     legend.labels.template.setAll({
//       oversizedBehavior: "wrap",
//       maxWidth: 250,
//       fontSize: 12,
//       paddingLeft: 8,
//       paddingRight: 8,
//     });

//     legend.itemContainers.template.setAll({
//       width: am5.percent(45),
//       paddingTop: 5,
//       paddingBottom: 5,
//     });

//     legend.data.setAll(chart.series.values);

//     return () => {
//       root.dispose();
//     };
//   }, [chartData, localCompanies]);

//   // ── toggle helpers ───────────────────────────────────────────────────────
//   //   const toggleCompany = (comp) => {
//   //     setLocalCompanies((prev) => {
//   //       const exists = prev.find((c) => c.value === comp.value);
//   //       return exists
//   //         ? prev.filter((c) => c.value !== comp.value)
//   //         : [...prev, comp];
//   //     });
//   //   };

//   const toggleCompany = (comp) => {
//     setLocalCompanies((prev) => {
//       const exists = prev.find((c) => c.value === comp.value);
//       if (exists) {
//         return prev.filter((c) => c.value !== comp.value);
//       }
//       return mergeUniqueCompanies(prev, [comp]);
//     });
//   };

//   //   const applyMetricFilter = () => {
//   //     setUpdatingMetrics(true);
//   //     setTimeout(() => {
//   //       setLocalMetrics([...metricDraft]);
//   //       setShowMetricFilter(false);
//   //       setUpdatingMetrics(false);
//   //     }, 500);
//   //   };

//   const applyMetricFilter = () => {
//     setUpdatingMetrics(true);
//     setTimeout(() => {
//       setLocalMetrics([...new Set(metricDraft)]);
//       setShowMetricFilter(false);
//       setUpdatingMetrics(false);
//     }, 500);
//   };

//   // Panel: companies shown inside filter card (show more/less)
//   const panelCompanies = showAllPanelCompanies
//     ? competitorOptions
//     : competitorOptions.slice(0, PANEL_SHOW_DEFAULT);

//   // Panel: metrics shown inside filter card (show more/less)
//   const panelMetrics = showAllPanelMetrics
//     ? availableMetrics
//     : availableMetrics.slice(0, PANEL_SHOW_DEFAULT);

//   // Selected company badges below filter row (show more/less)
//   const visibleSelectedCompanies = showAllSelectedCompanies
//     ? localCompanies
//     : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

//   if (!financialData.length) return null;

//   return (
//     <div className="container mt-4 heatmap_wrapper">
//       <h3 className="mb-3 heatmap_head">Financial Performance - Bar Chart</h3>

//       {/* ── Filter buttons row (matches heatmap button style) ── */}
//       <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
//         <button
//           // className="btn mt-4 ml-3 heatmap_filter_metrics"
//           className="btn mt-4 heatmap_filter_metrics"
//           onClick={() => {
//             setShowCompanyFilter((prev) => !prev);
//             setShowMetricFilter(false);
//           }}
//         >
//           Filter Companies
//         </button>

//         <button
//           className="btn mt-4 ml-3 heatmap_filter_metrics"
//           onClick={() => {
//             setMetricDraft(localMetrics);
//             setShowMetricFilter((prev) => !prev);
//             setShowCompanyFilter(false);
//           }}
//         >
//           Filter Metrics
//         </button>
//       </div>

//       {/* ── Company filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showCompanyFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Companies
//           </label>

//           {/* <div className="d-flex flex-wrap selected_companies_tags"> */}
//           {/* {panelCompanies.map((comp) => {
//               const isSelected = !!localCompanies.find(
//                 (c) => c.value === comp.value
//               );
//               return (
//                 <div
//                   key={comp.value}
//                   className={`badge p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges ${
//                     isSelected ? "badge-primary" : "badge-light"
//                   }`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   {comp.label}
//                   {isSelected && (
//                     <span
//                       className="ml-2"
//                       style={{ fontWeight: "bold" }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         toggleCompany(comp);
//                       }}
//                     >
//                       ×
//                     </span>
//                   )}
//                 </div>
//               );
//             })} */}
//           {/* </div> */}
//           <Select
//             isMulti
//             //   options={competitorOptions}
//             options={mergeUniqueCompanies(competitorOptions)}
//             value={localCompanies}
//             className="font13 search_competitors_select"
//             placeholder="Search companies..."
//             closeMenuOnSelect={false}
//             isClearable={false}
//             backspaceRemovesValue={false}
//             hideSelectedOptions={false}
//             components={{ Option: CheckboxOption }}
//             controlShouldRenderValue={false}
//             onChange={(list) => setLocalCompanies(list || [])}
//           />

//           {/* Show more / Show less inside panel */}
//           {/* {competitorOptions.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelCompanies((prev) => !prev)}
//             >
//               {showAllPanelCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     competitorOptions.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )} */}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowCompanyFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localCompanies.length}
//           </small>
//         </div>
//       )}

//       {/* ── Metric filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showMetricFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Metrics
//           </label>

//           {/* <div className="d-flex flex-wrap selected_companies_tags">
//             {panelMetrics.map((metric) => {
//               const isSelected = metricDraft.includes(metric);
//               return (
//                 <div
//                   key={metric}
//                   className={`badge p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges ${
//                     isSelected ? "badge-primary" : "badge-light"
//                   }`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() =>
//                     setMetricDraft((prev) =>
//                       isSelected
//                         ? prev.filter((m) => m !== metric)
//                         : [...prev, metric]
//                     )
//                   }
//                 >
//                   {formatMetricLabel(metric)}
//                   {isSelected && (
//                     <span
//                       className="ml-2"
//                       style={{ fontWeight: "bold" }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setMetricDraft((prev) =>
//                           prev.filter((m) => m !== metric)
//                         );
//                       }}
//                     >
//                       ×
//                     </span>
//                   )}
//                 </div>
//               );
//             })}
//           </div> */}

//           {/* <Select
//             isMulti
//             closeMenuOnSelect={false}
//             // options={availableMetrics.map((m) => ({
//             //   label: formatMetricLabel(m),
//             //   value: m,
//             // }))}
//             options={groupedMetricOptions}
//             value={availableMetrics
//               .map((m) => ({ label: formatMetricLabel(m), value: m }))
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Group: CollapsibleGroup,
//               GroupHeading: CollapsibleGroupHeading,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           /> */}

//           <Select
//             isMulti
//             className="font13 search_competitors_select"
//             closeMenuOnSelect={false}
//             hideSelectedOptions={false}
//             controlShouldRenderValue={false}
//             options={groupedMetricOptions}
//             value={groupedMetricOptions
//               .flatMap((group) => group.options)
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Option: CheckboxOption,
//               MenuList: CollapsibleMenuList,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           />

//           {/* Show more / Show less inside panel */}
//           {availableMetrics.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelMetrics((prev) => !prev)}
//             >
//               {showAllPanelMetrics
//                 ? "Show Less"
//                 : `Show More (${
//                     availableMetrics.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-primary btn-sm select_heatmap_apply_btn"
//               onClick={applyMetricFilter}
//               disabled={metricDraft.length === 0 || updatingMetrics}
//             >
//               Apply
//             </button>
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowMetricFilter(false)}
//             >
//               Cancel
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {metricDraft.length}
//           </small>
//         </div>
//       )}

//       {updatingMetrics && (
//         <div className="mt-2 text-primary font14">Updating filters...</div>
//       )}

//       {/* ── Active selected company badges ── */}
//       {localCompanies.length > 0 && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Showing Companies
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             {visibleSelectedCompanies.map((comp) => (
//               <div
//                 key={comp.value}
//                 className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
//               >
//                 {comp.label}
//                 <span
//                   className="ml-2"
//                   style={{ cursor: "pointer", fontWeight: "bold" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   ×
//                 </span>
//               </div>
//             ))}
//           </div>

//           {/* Show more / Show less for active badges */}
//           {localCompanies.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
//             >
//               {showAllSelectedCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     localCompanies.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}
//         </div>
//       )}

//       {/* ── Chart ── */}
//       {/* <div ref={chartRef} style={{ width: "100%", height: "350px" }} /> */}
//       <div
//         style={{
//           width: "100%",
//           overflowX: "auto",
//           overflowY: "hidden",
//           position: "relative",
//         }}
//       >
//         <div
//           ref={chartRef}
//           style={{
//             width: `${Math.max(chartData.length * 180, 1000)}px`,
//             minHeight: "420px",
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default GroupedBarChart;

// import React, {
//   useLayoutEffect,
//   useRef,
//   useState,
//   useEffect,
//   useMemo,
// } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import Select from "react-select";
// import { components } from "react-select";
// import APP_CONFIG from "../../config/appConfig";

// // ── Constants ─────────────────────────────────────────────────────────────────

// const MAX_DEFAULT_COMPANIES = 3;
// const MAX_DEFAULT_METRICS = 4;
// // How many options to show before "Show More" inside each filter panel
// const PANEL_SHOW_DEFAULT = 5;

// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: 8 }}
//       />
//       {props.label}
//     </components.Option>
//   );
// };

// const mergeUniqueCompanies = (...lists) => {
//   const map = new Map();
//   lists.flat().forEach((c) => {
//     if (c && !map.has(c.value)) {
//       map.set(c.value, c);
//     }
//   });
//   return Array.from(map.values());
// };

// // ++++++++++++++++++++++++++++++++++++++++++++++
// const buildGroupedMetricOptions = (availableMetrics) => {
//   return Object.entries(APP_CONFIG?.METRIC_GROUPS)
//     .map(([group, metrics]) => {
//       const options = metrics
//         .filter((metric) => availableMetrics.includes(metric))
//         .map((metric) => ({
//           label: formatMetricLabel(metric),
//           value: metric,
//         }));

//       return options.length
//         ? {
//             label: group,
//             options,
//           }
//         : null;
//     })
//     .filter(Boolean);
// };
// const CollapsibleMenuList = (props) => {
//   const { children, selectProps } = props;

//   const { collapsedGroups, setCollapsedGroups } = selectProps;

//   return (
//     <components.MenuList {...props}>
//       {React.Children.map(children, (group) => {
//         if (!group?.props?.data) return group;

//         const label = group.props.data.label;

//         const isCollapsed = collapsedGroups?.includes(label);

//         return (
//           <div>
//             {/* Group Header */}
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();

//                 setCollapsedGroups((prev) =>
//                   isCollapsed
//                     ? prev.filter((g) => g !== label)
//                     : [...prev, label]
//                 );
//               }}
//               style={{
//                 cursor: "pointer",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 padding: "8px 12px",
//                 background: "#f8f9fa",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               {isCollapsed ? "▶" : "▼"} {label}
//             </div>

//             {/* Group Options */}
//             {!isCollapsed && group}
//           </div>
//         );
//       })}
//     </components.MenuList>
//   );
// };
// // ++++++++++++++++++++++++++++++++++++++++++++++

// const BAR_COLORS = [
//   0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
//   0xd35400,
// ];

// const formatMetricLabel = (metric) =>
//   APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

// // ── Helpers ───────────────────────────────────────────────────────────────────

// // const deriveAvailableMetrics = (financialData) => {
// //   if (!financialData?.length) return [];
// //   const metricSet = new Set();
// //   financialData.forEach((company) => {
// //     company.metrics?.forEach((m) => {
// //       if (m.value !== null && m.value !== undefined) metricSet.add(m.metric);
// //     });
// //   });
// //   return Array.from(metricSet);
// // };

// const deriveAvailableMetrics = (financialData) => {
//   if (!financialData?.length) return [];

//   const metricSet = new Set();

//   financialData.forEach((company) => {
//     company.metrics?.forEach((m) => {
//       if (m.metric && m.value !== null && m.value !== undefined) {
//         metricSet.add(m.metric);
//       }
//     });
//   });

//   return Array.from(metricSet);
// };

// /**
//  * Build amCharts data: one row per metric, one field per company.
//  * { metricLabel: "Total Revenue", "CompanyA": 1234, "CompanyB": 5678 }
//  */
// const buildChartData = (financialData, activeCompanies, activeMetrics) => {
//   if (
//     !financialData?.length ||
//     !activeCompanies?.length ||
//     !activeMetrics?.length
//   )
//     return [];

//   return activeMetrics.map((metric) => {
//     const row = { metricLabel: formatMetricLabel(metric) };
//     activeCompanies.forEach((comp) => {
//       const compData = financialData.find(
//         (fd) => fd.vendor_company_id === comp.value
//       );
//       const metricEntry = compData?.metrics?.find((m) => m.metric === metric);
//       // row[comp.label] = metricEntry?.value ?? 0;
//       // row[comp.label] =
//       //   metricEntry?.value != null ? metricEntry.value / 1e9 : 0;
//       row[comp.label] = metricEntry?.value ?? 0;
//     });
//     return row;
//   });
// };

// // ── Component ─────────────────────────────────────────────────────────────────

// /**
//  * GroupedBarChart
//  *
//  * Props from parent (FinancialPerformance):
//  *  - financialData     : array of { vendor_company_id, company_name, metrics[] }
//  *  - competitorOptions : array of { label, value } — master selected competitors
//  *
//  * All filters here are LOCAL — they only affect the bar chart, not the heatmap.
//  */
// const GroupedBarChart = ({ financialData = [], competitorOptions = [] }) => {
//   const chartRef = useRef(null);

//   // ── derive available metrics from fetched data ───────────────────────────
//   const availableMetrics = useMemo(
//     () => deriveAvailableMetrics(financialData),
//     [financialData]
//   );

//   // +++++++++++++++++++++++++++++++++++++
//   const groupedMetricOptions = useMemo(
//     () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
//     [availableMetrics]
//   );
//   // +++++++++++++++++++++++++++++++++++++

//   // ── local filter state ───────────────────────────────────────────────────
//   // Companies shown in bar chart (default: first MAX_DEFAULT_COMPANIES)
//   const [localCompanies, setLocalCompanies] = useState(() =>
//     competitorOptions.slice(0, MAX_DEFAULT_COMPANIES)
//   );
//   //   // Metrics shown in bar chart (default: first MAX_DEFAULT_METRICS)
//   //   const [localMetrics, setLocalMetrics] = useState(() =>
//   //     availableMetrics.slice(0, MAX_DEFAULT_METRICS)
//   //   );
//   //   // Metric draft (Apply/Cancel pattern matching heatmap)
//   //   const [metricDraft, setMetricDraft] = useState(() =>
//   //     availableMetrics.slice(0, MAX_DEFAULT_METRICS)
//   //   );

//   const [localMetrics, setLocalMetrics] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   const [metricDraft, setMetricDraft] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   // Filter panel open/close
//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);
//   const [showMetricFilter, setShowMetricFilter] = useState(false);

//   const [updatingMetrics, setUpdatingMetrics] = useState(false);

//   // Show more/less inside filter panels
//   const [showAllPanelCompanies, setShowAllPanelCompanies] = useState(false);
//   const [showAllPanelMetrics, setShowAllPanelMetrics] = useState(false);

//   // Show more/less for selected company badges below chart filters
//   const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
//     useState(false);

//   const [collapsedGroups, setCollapsedGroups] = useState(
//     Object.keys(APP_CONFIG?.METRIC_GROUPS)
//   );

//   // Sync localCompanies when master competitorOptions changes
//   //   useEffect(() => {
//   //     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   //   }, [competitorOptions]);

//   // useEffect(() => {
//   //     const unique = mergeUniqueCompanies(competitorOptions);
//   //     setLocalCompanies(unique.slice(0, MAX_DEFAULT_COMPANIES));
//   //   }, [competitorOptions]);

//   // const prevRef = useRef(competitorOptions);

//   // useEffect(() => {
//   //   const prev = prevRef.current;

//   //   const added = competitorOptions.filter(
//   //     (c) => !prev.find((p) => p.value === c.value)
//   //   );

//   //   if (added.length) {
//   //     setLocalCompanies((curr) => mergeUniqueCompanies(curr, added));
//   //   }

//   //   // remove if deleted from master
//   //   setLocalCompanies((curr) =>
//   //     curr.filter((c) => competitorOptions.find((opt) => opt.value === c.value))
//   //   );

//   //   prevRef.current = competitorOptions;
//   // }, [competitorOptions]);

//   useEffect(() => {
//     if (!competitorOptions.length) return;
//     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   }, [competitorOptions]);

//   // Sync localMetrics when available metrics change
//   //   useEffect(() => {
//   //     const defaults = availableMetrics.slice(0, MAX_DEFAULT_METRICS);
//   //     setLocalMetrics(defaults);
//   //     setMetricDraft(defaults);
//   //   }, [availableMetrics]);

//   useEffect(() => {
//     const unique = [...new Set(availableMetrics)];
//     const defaults = unique.slice(0, MAX_DEFAULT_METRICS);

//     setLocalMetrics(defaults);
//     setMetricDraft(defaults);
//   }, [availableMetrics]);

//   // ── chart data ───────────────────────────────────────────────────────────
//   const chartData = useMemo(
//     () => buildChartData(financialData, localCompanies, localMetrics),
//     [financialData, localCompanies, localMetrics]
//   );

//   // ── amCharts rendering ───────────────────────────────────────────────────
//   // useLayoutEffect(() => {
//   //   if (!chartData.length || !localCompanies.length) return;

//   //   let root = am5.Root.new(chartRef.current);
//   //   root._logo.dispose();
//   //   root.setThemes([am5themes_Animated.new(root)]);

//   //   let chart = root.container.children.push(
//   //     am5xy.XYChart.new(root, {
//   //       layout: root.verticalLayout,
//   //       panX: false,
//   //       panY: false,

//   //       paddingTop: 20,
//   //       paddingBottom: 20,
//   //       paddingLeft: 20,
//   //       paddingRight: 20,
//   //     })
//   //   );

//   //   let xAxis = chart.xAxes.push(
//   //     am5xy.CategoryAxis.new(root, {
//   //       categoryField: "metricLabel",
//   //       renderer: am5xy.AxisRendererX.new(root, {
//   //         cellStartLocation: 0.1,
//   //         cellEndLocation: 0.9,

//   //         minGridDistance: 40, // spacing between labels
//   //       }),
//   //     })
//   //   );

//   //   xAxis.get("renderer").labels.template.setAll({
//   //     paddingTop: 10,
//   //     oversizedBehavior: "wrap",
//   //     maxWidth: 120,
//   //     textAlign: "center",
//   //   });

//   //   xAxis.data.setAll(chartData);

//   //   chart.yAxes.push(
//   //     am5xy.ValueAxis.new(root, {
//   //       renderer: am5xy.AxisRendererY.new(root, {}),
//   //       min: 0,
//   //     })
//   //   );

//   //   // const yAxis = chart.yAxes.getIndex(0);
//   //   const yAxis = chart.yAxes.push(
//   //     am5xy.ValueAxis.new(root, {
//   //       renderer: am5xy.AxisRendererY.new(root, {}),
//   //       min: 0,
//   //     })
//   //   );

//   //   yAxis.get("renderer").labels.template.setAll({
//   //     paddingRight: 10,
//   //   });

//   //   yAxis.get("renderer").labels.template.adapters.add("text", (text) => {
//   //     return text ? text + "B" : text;
//   //   });

//   //   localCompanies.forEach((comp, idx) => {
//   //     const color = BAR_COLORS[idx % BAR_COLORS.length];
//   //     const series = chart.series.push(
//   //       am5xy.ColumnSeries.new(root, {
//   //         name: comp.label,
//   //         xAxis,
//   //         yAxis,
//   //         valueYField: comp.label,
//   //         categoryXField: "metricLabel",
//   //         fill: am5.color(color),
//   //         stroke: am5.color(color),
//   //         clustered: true,
//   //       })
//   //     );
//   //     series.columns.template.setAll({
//   //       // tooltipText: "{name}: {valueY}",
//   //       tooltipText: "{name}: {valueY}B",
//   //       width: am5.percent(60),
//   //     });
//   //     series.data.setAll(chartData);
//   //   });

//   //   chart.set("cursor", am5xy.XYCursor.new(root, {}));

//   //   // root.container.children
//   //   //   .push(
//   //   //     am5.Legend.new(root, {
//   //   //       centerX: am5.p50,
//   //   //       x: am5.p50,
//   //   //       layout: root.horizontalLayout,
//   //   //     })
//   //   //   )
//   //   //   .data.setAll(chart.series.values);

//   //   let legend = chart.children.push(
//   //     am5.Legend.new(root, {
//   //       centerX: am5.p50,
//   //       x: am5.p50,
//   //       layout: root.horizontalLayout,

//   //       paddingTop: 15,
//   //       paddingBottom: 10,
//   //     })
//   //   );

//   //   legend.labels.template.setAll({
//   //     paddingLeft: 8,
//   //     paddingRight: 8,
//   //   });

//   //   legend.itemContainers.template.setAll({
//   //     paddingRight: 15,
//   //     paddingTop: 5,
//   //     paddingBottom: 5,
//   //   });

//   //   legend.data.setAll(chart.series.values);

//   //   return () => root.dispose();
//   // }, [chartData, localCompanies]);

//   useLayoutEffect(() => {
//     if (!chartData.length || !localCompanies.length) return;

//     let root = am5.Root.new(chartRef.current);
//     root._logo.dispose();
//     root.setThemes([am5themes_Animated.new(root)]);

//     // Dynamic width for native horizontal scroll
//     // const categoryWidth = 180;
//     const categoryWidth = Math.max(140, localCompanies.length * 45);
//     const chartWidth = Math.max(
//       chartData.length * categoryWidth,
//       chartRef.current?.offsetWidth || 1200
//     );

//     // ─────────────────────────────────────
//     // Chart
//     // ─────────────────────────────────────
//     let chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         layout: root.verticalLayout,

//         panX: false,
//         panY: false,

//         wheelX: "none",
//         wheelY: "none",

//         paddingTop: 20,
//         // paddingBottom: 20,
//         paddingBottom: 45,
//         paddingLeft: 10,
//         paddingRight: 20,
//       })
//     );

//     // Native horizontal scroll support
//     chart.plotContainer.set("width", chartWidth);

//     // ─────────────────────────────────────
//     // X Axis
//     // ─────────────────────────────────────
//     // const xRenderer = am5xy.AxisRendererX.new(root, {
//     //   minGridDistance: 60,
//     //   cellStartLocation: 0.15,
//     //   cellEndLocation: 0.85,
//     // });

//     // const xAxis = chart.xAxes.push(
//     //   am5xy.CategoryAxis.new(root, {
//     //     categoryField: "metricLabel",
//     //     renderer: xRenderer,
//     //   })
//     // );

//     // xAxis.data.setAll(chartData);

//     // // Label styles
//     // xRenderer.labels.template.setAll({
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   paddingTop: 10,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",
//     //   tooltipY: 0,
//     // });

//     // // FULL TOOLTIP LABEL
//     // xRenderer.labels.template.setup = (target) => {
//     //   target.set(
//     //     "tooltip",
//     //     am5.Tooltip.new(root, {
//     //       labelText: "{category}",
//     //       pointerOrientation: "up",
//     //     })
//     //   );
//     // };

//     // // Proper truncated label text
//     // xRenderer.labels.template.adapters.add("text", (text) => {
//     //   if (!text) return "";

//     //   return text.length > 16 ? `${text.substring(0, 16)}...` : text;
//     // });

//     // // Full tooltip label
//     // xRenderer.labels.template.adapters.add("tooltipText", (_, target) => {
//     //   return target.dataItem?.dataContext?.metricLabel || "";
//     // });

//     // xAxis.get("tooltip")?.label.setAll({
//     //   oversizedBehavior: "wrap",
//     // });

//     // ─────────────────────────────────────
//     // X Axis
//     // ─────────────────────────────────────
//     const xRenderer = am5xy.AxisRendererX.new(root, {
//       // minGridDistance: 60,
//       minGridDistance: 90,
//       cellStartLocation: 0.15,
//       cellEndLocation: 0.85,
//     });

//     const xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         categoryField: "metricLabel",
//         renderer: xRenderer,
//       })
//     );

//     xAxis.data.setAll(chartData);

//     // Store original label separately
//     // xRenderer.labels.template.setAll({
//     //   paddingTop: 10,
//     //   oversizedBehavior: "none",
//     //   textAlign: "center",
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",
//     //   maxWidth: 120,
//     //   fontSize: 12,
//     // });

//     // // Proper truncate with original preservation
//     // xRenderer.labels.template.adapters.add("text", (text, target) => {
//     //   if (!text) return "";

//     //   // Store full text
//     //   target.setPrivate("fullText", text);

//     //   return text.length > 12 ? `${text.slice(0, 12)}...` : text;
//     // });

//     // // REAL TOOLTIP
//     // xRenderer.labels.template.events.on("pointerover", (ev) => {
//     //   const label = ev.target;

//     //   const fullText = label.getPrivate("fullText");

//     //   if (!fullText) return;

//     //   if (!label.get("tooltip")) {
//     //     label.set(
//     //       "tooltip",
//     //       am5.Tooltip.new(root, {
//     //         pointerOrientation: "up",
//     //         labelText: fullText,
//     //       })
//     //     );
//     //   }

//     //   label.get("tooltip").label.setAll({
//     //     text: fullText,
//     //     oversizedBehavior: "wrap",
//     //     maxWidth: 300,
//     //   });

//     //   label.showTooltip();
//     // });

//     // // Click support
//     // xRenderer.labels.template.events.on("click", (ev) => {
//     //   const fullText = ev.target.getPrivate("fullText");

//     //   if (fullText) {
//     //     alert(fullText);
//     //   }
//     // });

//     // xRenderer.labels.template.setAll({
//     //   paddingTop: 12,
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   centerX: am5.p50,
//     //   fontSize: 11,
//     //   tooltipY: 0,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",

//     //   tooltip: am5.Tooltip.new(root, {
//     //     pointerOrientation: "up",
//     //   }),
//     // });

//     // // Better truncation
//     // xRenderer.labels.template.adapters.add("text", (text, target) => {
//     //   if (!text) return "";

//     //   target.setPrivate("fullText", text);

//     //   return text.length > 14 ? `${text.substring(0, 14)}...` : text;
//     // });

//     // // Full tooltip on hover
//     // xRenderer.labels.template.adapters.add(
//     //   "tooltipText",
//     //   (_, target) => target.getPrivate("fullText") || ""
//     // );

//     // xRenderer.labels.template.setAll({
//     //   paddingTop: 12,
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   centerX: am5.p50,
//     //   fontSize: 11,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",
//     // });

//     // // Truncate only visually
//     // xRenderer.labels.template.adapters.add("text", (text, target) => {
//     //   if (!text) return "";

//     //   target.setPrivate("fullText", text);

//     //   return text.length > 14 ? `${text.substring(0, 14)}...` : text;
//     // });

//     // // Tooltip ONLY for x-axis labels
//     // xRenderer.labels.template.adapters.add(
//     //   "tooltipText",
//     //   (_, target) => target.getPrivate("fullText") || ""
//     // );

//     // // Create tooltip
//     // xRenderer.labels.template.setup = (target) => {
//     //   target.set(
//     //     "tooltip",
//     //     am5.Tooltip.new(root, {
//     //       pointerOrientation: "up",
//     //       labelText: "{tooltipText}",
//     //     })
//     //   );
//     // };

//     // xRenderer.labels.template.setAll({
//     //   paddingTop: 12,
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   centerX: am5.p50,
//     //   fontSize: 11,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",

//     //   tooltip: am5.Tooltip.new(root, {
//     //     pointerOrientation: "up",
//     //   }),
//     // });

//     // xRenderer.labels.template.setAll({
//     //   paddingTop: 12,
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   centerX: am5.p50,
//     //   fontSize: 11,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",
//     //   tooltip: am5.Tooltip.new(root, {
//     //     pointerOrientation: "up",
//     //     labelText: "{text}", // <-- Add this line
//     //   }),
//     // });

//     // // Truncate label visually only
//     // xRenderer.labels.template.adapters.add("text", (text, target) => {
//     //   if (!text) return "";

//     //   target.setPrivate("fullText", text);

//     //   return text.length > 16 ? `${text.substring(0, 16)}...` : text;
//     // });

//     // // Show full label in tooltip on hover
//     // xRenderer.labels.template.adapters.add(
//     //   "tooltipText",
//     //   (_, target) => target.getPrivate("fullText") || ""
//     // );

//     // // Ensure tooltip appears immediately
//     // xRenderer.labels.template.events.on("pointerover", (ev) => {
//     //   const label = ev.target;

//     //   const fullText = label.getPrivate("fullText");

//     //   if (!fullText) return;

//     //   const tooltip = label.get("tooltip");

//     //   if (tooltip) {
//     //     tooltip.label.setAll({
//     //       text: fullText,
//     //       oversizedBehavior: "wrap",
//     //       maxWidth: 300,
//     //     });

//     //     label.showTooltip();
//     //   }
//     // });

//     // xRenderer.labels.template.setAll({
//     //   paddingTop: 12,
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 110,
//     //   textAlign: "center",
//     //   centerX: am5.p50,
//     //   fontSize: 11,
//     //   interactive: true,
//     //   cursorOverStyle: "pointer",
//     //   tooltip: am5.Tooltip.new(root, {
//     //     pointerOrientation: "up",
//     //     labelText: "{text}",
//     //   }),
//     // });

//     // // Manually show tooltip on pointerover
//     // xRenderer.labels.template.events.on("pointerover", function (ev) {
//     //   ev.target.showTooltip();
//     // });
//     // xRenderer.labels.template.events.on("pointerout", function (ev) {
//     //   ev.target.hideTooltip();
//     // });

//     // Create a single tooltip instance for reuse
//     // const labelTooltip = am5.Tooltip.new(root, {
//     //   pointerOrientation: "up",
//     //   labelText: "{text}",
//     //   zIndex: 10000, // Ensure tooltip is on top
//     // });

//     const labelTooltip = am5.Tooltip.new(root, {
//       pointerOrientation: "down",
//       labelText: "{text}",
//       zIndex: 10000, // Ensure tooltip is on top
//     });
//     xRenderer.labels.template.setAll({
//       paddingTop: 12,
//       oversizedBehavior: "truncate",
//       maxWidth: 110,
//       textAlign: "center",
//       centerX: am5.p50,
//       fontSize: 11,
//       interactive: true,
//       cursor: "pointer",
//       tooltip: labelTooltip,
//     });

//     // // Explicitly set tooltip target and show/hide on events
//     xRenderer.labels.template.events.on("pointerover", function (ev) {
//       labelTooltip.set("target", ev.target);
//       ev.target.showTooltip();
//     });
//     xRenderer.labels.template.events.on("pointerout", function (ev) {
//       ev.target.hideTooltip();
//     });

//     labelTooltip.set("labelText", "Test Tooltip");

//     // ─────────────────────────────────────
//     // Y Axis
//     // ─────────────────────────────────────
//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     yAxis.get("renderer").labels.template.setAll({
//       paddingRight: 10,
//     });

//     // Remove B suffix completely
//     yAxis.get("renderer").labels.template.adapters.add("text", (text) => text);

//     // Axis title
//     yAxis.children.unshift(
//       am5.Label.new(root, {
//         text: "Values in Billions",
//         rotation: -90,
//         y: am5.p50,
//         centerX: am5.p50,
//         fontSize: 13,
//       })
//     );

//     // ─────────────────────────────────────
//     // Series
//     // ─────────────────────────────────────
//     localCompanies.forEach((comp, idx) => {
//       const color = BAR_COLORS[idx % BAR_COLORS.length];

//       const series = chart.series.push(
//         am5xy.ColumnSeries.new(root, {
//           name: comp.label,
//           xAxis,
//           yAxis,
//           valueYField: comp.label,
//           categoryXField: "metricLabel",

//           fill: am5.color(color),
//           stroke: am5.color(color),

//           clustered: true,
//         })
//       );

//       series.columns.template.setAll({
//         width: am5.percent(65),
//         tooltipText: "{name}\n{categoryX}\n{valueY}",
//       });

//       series.data.setAll(chartData);
//     });

//     // ─────────────────────────────────────
//     // Cursor
//     // ─────────────────────────────────────
//     chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         behavior: "none",
//       })
//     );

//     // ─────────────────────────────────────
//     // Legend
//     // ─────────────────────────────────────
//     // const legend = chart.children.push(
//     //   am5.Legend.new(root, {
//     //     centerX: am5.p50,
//     //     x: am5.p50,
//     //     width: am5.percent(100),

//     //     layout: root.horizontalLayout,

//     //     paddingTop: 15,
//     //     paddingBottom: 10,
//     //   })
//     // );

//     // // FULL LEGEND LABELS
//     // legend.labels.template.setAll({
//     //   oversizedBehavior: "wrap",
//     //   maxWidth: 250,
//     //   fontSize: 12,
//     //   paddingLeft: 8,
//     //   paddingRight: 8,
//     // });

//     // legend.itemContainers.template.setAll({
//     //   width: am5.percent(45),
//     //   paddingTop: 5,
//     //   paddingBottom: 5,
//     // });

//     // legend.data.setAll(chart.series.values);

//     // ─────────────────────────────────────
//     // Legend
//     // ─────────────────────────────────────
//     const legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,
//         width: am5.percent(100),

//         layout: root.gridLayout,

//         useDefaultMarker: true,

//         paddingTop: 20,
//         paddingBottom: 10,
//       })
//     );

//     // Prevent overlap
//     legend.itemContainers.template.setAll({
//       width: am5.percent(33),
//       paddingBottom: 8,
//       paddingTop: 8,
//     });

//     // Legend labels
//     // legend.labels.template.setAll({
//     //   oversizedBehavior: "truncate",
//     //   maxWidth: 160,
//     //   fontSize: 12,

//     //   tooltipText: "{name}",
//     // });
//     legend.labels.template.setAll({
//       // oversizedBehavior: "wrap",
//       maxWidth: 220,
//       fontSize: 12,
//       breakWords: true,
//     });

//     // Optional better spacing
//     legend.markerRectangles.template.setAll({
//       cornerRadiusTL: 4,
//       cornerRadiusTR: 4,
//       cornerRadiusBL: 4,
//       cornerRadiusBR: 4,
//     });

//     legend.data.setAll(chart.series.values);

//     return () => {
//       root.dispose();
//     };
//   }, [chartData, localCompanies]);

//   // ── toggle helpers ───────────────────────────────────────────────────────
//   //   const toggleCompany = (comp) => {
//   //     setLocalCompanies((prev) => {
//   //       const exists = prev.find((c) => c.value === comp.value);
//   //       return exists
//   //         ? prev.filter((c) => c.value !== comp.value)
//   //         : [...prev, comp];
//   //     });
//   //   };

//   const toggleCompany = (comp) => {
//     setLocalCompanies((prev) => {
//       const exists = prev.find((c) => c.value === comp.value);
//       if (exists) {
//         return prev.filter((c) => c.value !== comp.value);
//       }
//       return mergeUniqueCompanies(prev, [comp]);
//     });
//   };

//   //   const applyMetricFilter = () => {
//   //     setUpdatingMetrics(true);
//   //     setTimeout(() => {
//   //       setLocalMetrics([...metricDraft]);
//   //       setShowMetricFilter(false);
//   //       setUpdatingMetrics(false);
//   //     }, 500);
//   //   };

//   const applyMetricFilter = () => {
//     setUpdatingMetrics(true);
//     setTimeout(() => {
//       setLocalMetrics([...new Set(metricDraft)]);
//       setShowMetricFilter(false);
//       setUpdatingMetrics(false);
//     }, 500);
//   };

//   // Panel: companies shown inside filter card (show more/less)
//   const panelCompanies = showAllPanelCompanies
//     ? competitorOptions
//     : competitorOptions.slice(0, PANEL_SHOW_DEFAULT);

//   // Panel: metrics shown inside filter card (show more/less)
//   const panelMetrics = showAllPanelMetrics
//     ? availableMetrics
//     : availableMetrics.slice(0, PANEL_SHOW_DEFAULT);

//   // Selected company badges below filter row (show more/less)
//   const visibleSelectedCompanies = showAllSelectedCompanies
//     ? localCompanies
//     : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

//   if (!financialData.length) return null;

//   return (
//     <div className="container mt-4 heatmap_wrapper">
//       <h3 className="mb-3 heatmap_head">Financial Performance - Bar Chart</h3>

//       {/* ── Filter buttons row (matches heatmap button style) ── */}
//       <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
//         <button
//           // className="btn mt-4 ml-3 heatmap_filter_metrics"
//           className="btn mt-4 heatmap_filter_metrics"
//           onClick={() => {
//             setShowCompanyFilter((prev) => !prev);
//             setShowMetricFilter(false);
//           }}
//         >
//           Filter Companies
//         </button>

//         <button
//           className="btn mt-4 ml-3 heatmap_filter_metrics"
//           onClick={() => {
//             setMetricDraft(localMetrics);
//             setShowMetricFilter((prev) => !prev);
//             setShowCompanyFilter(false);
//           }}
//         >
//           Filter Metrics
//         </button>
//       </div>

//       {/* ── Company filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showCompanyFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Companies
//           </label>

//           {/* <div className="d-flex flex-wrap selected_companies_tags"> */}
//           {/* {panelCompanies.map((comp) => {
//               const isSelected = !!localCompanies.find(
//                 (c) => c.value === comp.value
//               );
//               return (
//                 <div
//                   key={comp.value}
//                   className={`badge p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges ${
//                     isSelected ? "badge-primary" : "badge-light"
//                   }`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   {comp.label}
//                   {isSelected && (
//                     <span
//                       className="ml-2"
//                       style={{ fontWeight: "bold" }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         toggleCompany(comp);
//                       }}
//                     >
//                       ×
//                     </span>
//                   )}
//                 </div>
//               );
//             })} */}
//           {/* </div> */}
//           <Select
//             isMulti
//             //   options={competitorOptions}
//             options={mergeUniqueCompanies(competitorOptions)}
//             value={localCompanies}
//             className="font13 search_competitors_select"
//             placeholder="Search companies..."
//             closeMenuOnSelect={false}
//             isClearable={false}
//             backspaceRemovesValue={false}
//             hideSelectedOptions={false}
//             components={{ Option: CheckboxOption }}
//             controlShouldRenderValue={false}
//             onChange={(list) => setLocalCompanies(list || [])}
//           />

//           {/* Show more / Show less inside panel */}
//           {/* {competitorOptions.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelCompanies((prev) => !prev)}
//             >
//               {showAllPanelCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     competitorOptions.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )} */}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowCompanyFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localCompanies.length}
//           </small>
//         </div>
//       )}

//       {/* ── Metric filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showMetricFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Metrics
//           </label>

//           {/* <div className="d-flex flex-wrap selected_companies_tags">
//             {panelMetrics.map((metric) => {
//               const isSelected = metricDraft.includes(metric);
//               return (
//                 <div
//                   key={metric}
//                   className={`badge p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges ${
//                     isSelected ? "badge-primary" : "badge-light"
//                   }`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() =>
//                     setMetricDraft((prev) =>
//                       isSelected
//                         ? prev.filter((m) => m !== metric)
//                         : [...prev, metric]
//                     )
//                   }
//                 >
//                   {formatMetricLabel(metric)}
//                   {isSelected && (
//                     <span
//                       className="ml-2"
//                       style={{ fontWeight: "bold" }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setMetricDraft((prev) =>
//                           prev.filter((m) => m !== metric)
//                         );
//                       }}
//                     >
//                       ×
//                     </span>
//                   )}
//                 </div>
//               );
//             })}
//           </div> */}

//           {/* <Select
//             isMulti
//             closeMenuOnSelect={false}
//             // options={availableMetrics.map((m) => ({
//             //   label: formatMetricLabel(m),
//             //   value: m,
//             // }))}
//             options={groupedMetricOptions}
//             value={availableMetrics
//               .map((m) => ({ label: formatMetricLabel(m), value: m }))
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Group: CollapsibleGroup,
//               GroupHeading: CollapsibleGroupHeading,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           /> */}

//           <Select
//             isMulti
//             className="font13 search_competitors_select"
//             closeMenuOnSelect={false}
//             hideSelectedOptions={false}
//             controlShouldRenderValue={false}
//             options={groupedMetricOptions}
//             value={groupedMetricOptions
//               .flatMap((group) => group.options)
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Option: CheckboxOption,
//               MenuList: CollapsibleMenuList,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           />

//           {/* Show more / Show less inside panel */}
//           {availableMetrics.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelMetrics((prev) => !prev)}
//             >
//               {showAllPanelMetrics
//                 ? "Show Less"
//                 : `Show More (${
//                     availableMetrics.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-primary btn-sm select_heatmap_apply_btn"
//               onClick={applyMetricFilter}
//               disabled={metricDraft.length === 0 || updatingMetrics}
//             >
//               Apply
//             </button>
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowMetricFilter(false)}
//             >
//               Cancel
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {metricDraft.length}
//           </small>
//         </div>
//       )}

//       {updatingMetrics && (
//         <div className="mt-2 text-primary font14">Updating filters...</div>
//       )}

//       {/* ── Active selected company badges ── */}
//       {localCompanies.length > 0 && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Showing Companies
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             {visibleSelectedCompanies.map((comp) => (
//               <div
//                 key={comp.value}
//                 className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
//               >
//                 {comp.label}
//                 <span
//                   className="ml-2"
//                   style={{ cursor: "pointer", fontWeight: "bold" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   ×
//                 </span>
//               </div>
//             ))}
//           </div>

//           {/* Show more / Show less for active badges */}
//           {localCompanies.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
//             >
//               {showAllSelectedCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     localCompanies.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}
//         </div>
//       )}

//       {/* ── Chart ── */}
//       {/* <div ref={chartRef} style={{ width: "100%", height: "350px" }} /> */}
//       <div
//         style={{
//           width: "100%",
//           overflowX: "auto",
//           overflowY: "hidden",
//           position: "relative",
//         }}
//       >
//         <div
//           ref={chartRef}
//           style={{
//             width: `${Math.max(chartData.length * 180, 1000)}px`,
//             minHeight: "420px",
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default GroupedBarChart;

// import React, {
//   useLayoutEffect,
//   useRef,
//   useState,
//   useEffect,
//   useMemo,
// } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import Select from "react-select";
// import { components } from "react-select";
// import APP_CONFIG from "../../config/appConfig";

// // ── Constants ─────────────────────────────────────────────────────────────────

// const MAX_DEFAULT_COMPANIES = 3;
// const MAX_DEFAULT_METRICS = 4;
// // How many options to show before "Show More" inside each filter panel
// const PANEL_SHOW_DEFAULT = 5;

// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: 8 }}
//       />
//       {props.label}
//     </components.Option>
//   );
// };

// const mergeUniqueCompanies = (...lists) => {
//   const map = new Map();
//   lists.flat().forEach((c) => {
//     if (c && !map.has(c.value)) {
//       map.set(c.value, c);
//     }
//   });
//   return Array.from(map.values());
// };

// // ++++++++++++++++++++++++++++++++++++++++++++++
// const buildGroupedMetricOptions = (availableMetrics) => {
//   return Object.entries(APP_CONFIG?.METRIC_GROUPS)
//     .map(([group, metrics]) => {
//       const options = metrics
//         .filter((metric) => availableMetrics.includes(metric))
//         .map((metric) => ({
//           label: formatMetricLabel(metric),
//           value: metric,
//         }));

//       return options.length
//         ? {
//             label: group,
//             options,
//           }
//         : null;
//     })
//     .filter(Boolean);
// };
// const CollapsibleMenuList = (props) => {
//   const { children, selectProps } = props;

//   const { collapsedGroups, setCollapsedGroups } = selectProps;

//   return (
//     <components.MenuList {...props}>
//       {React.Children.map(children, (group) => {
//         if (!group?.props?.data) return group;

//         const label = group.props.data.label;

//         const isCollapsed = collapsedGroups?.includes(label);

//         return (
//           <div>
//             {/* Group Header */}
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();

//                 setCollapsedGroups((prev) =>
//                   isCollapsed
//                     ? prev.filter((g) => g !== label)
//                     : [...prev, label]
//                 );
//               }}
//               style={{
//                 cursor: "pointer",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 padding: "8px 12px",
//                 background: "#f8f9fa",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               {isCollapsed ? "▶" : "▼"} {label}
//             </div>

//             {/* Group Options */}
//             {!isCollapsed && group}
//           </div>
//         );
//       })}
//     </components.MenuList>
//   );
// };

// const BAR_COLORS = [
//   0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
//   0xd35400,
// ];

// const formatMetricLabel = (metric) =>
//   APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

// const deriveAvailableMetrics = (financialData) => {
//   if (!financialData?.length) return [];

//   const metricSet = new Set();

//   financialData.forEach((company) => {
//     company.metrics?.forEach((m) => {
//       if (m.metric && m.value !== null && m.value !== undefined) {
//         metricSet.add(m.metric);
//       }
//     });
//   });

//   return Array.from(metricSet);
// };

// const buildChartData = (financialData, activeCompanies, activeMetrics) => {
//   if (
//     !financialData?.length ||
//     !activeCompanies?.length ||
//     !activeMetrics?.length
//   )
//     return [];

//   return activeMetrics.map((metric) => {
//     const row = { metricLabel: formatMetricLabel(metric) };
//     activeCompanies.forEach((comp) => {
//       const compData = financialData.find(
//         (fd) => fd.vendor_company_id === comp.value
//       );
//       const metricEntry = compData?.metrics?.find((m) => m.metric === metric);
//       row[comp.label] = metricEntry?.value ?? 0;
//     });
//     return row;
//   });
// };

// const GroupedBarChart = ({ financialData = [], competitorOptions = [] }) => {
//   const chartRef = useRef(null);

//   // ── derive available metrics from fetched data ───────────────────────────
//   const availableMetrics = useMemo(
//     () => deriveAvailableMetrics(financialData),
//     [financialData]
//   );

//   const groupedMetricOptions = useMemo(
//     () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
//     [availableMetrics]
//   );

//   const [localCompanies, setLocalCompanies] = useState(() =>
//     competitorOptions.slice(0, MAX_DEFAULT_COMPANIES)
//   );

//   const [localMetrics, setLocalMetrics] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   const [metricDraft, setMetricDraft] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   // Filter panel open/close
//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);
//   const [showMetricFilter, setShowMetricFilter] = useState(false);

//   const [updatingMetrics, setUpdatingMetrics] = useState(false);

//   // Show more/less inside filter panels
//   const [showAllPanelCompanies, setShowAllPanelCompanies] = useState(false);
//   const [showAllPanelMetrics, setShowAllPanelMetrics] = useState(false);

//   // Show more/less for selected company badges below chart filters
//   const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
//     useState(false);

//   const [collapsedGroups, setCollapsedGroups] = useState(
//     Object.keys(APP_CONFIG?.METRIC_GROUPS)
//   );

//   useEffect(() => {
//     if (!competitorOptions.length) return;
//     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   }, [competitorOptions]);

//   useEffect(() => {
//     const unique = [...new Set(availableMetrics)];
//     const defaults = unique.slice(0, MAX_DEFAULT_METRICS);

//     setLocalMetrics(defaults);
//     setMetricDraft(defaults);
//   }, [availableMetrics]);

//   // ── chart data ───────────────────────────────────────────────────────────
//   const chartData = useMemo(
//     () => buildChartData(financialData, localCompanies, localMetrics),
//     [financialData, localCompanies, localMetrics]
//   );

//   useLayoutEffect(() => {
//     if (!chartData.length || !localCompanies.length) return;

//     let root = am5.Root.new(chartRef.current);
//     root._logo.dispose();
//     root.setThemes([am5themes_Animated.new(root)]);

//     // Dynamic width for native horizontal scroll
//     // const categoryWidth = 180;
//     const categoryWidth = Math.max(140, localCompanies.length * 45);
//     const chartWidth = Math.max(
//       chartData.length * categoryWidth,
//       chartRef.current?.offsetWidth || 1200
//     );

//     // ─────────────────────────────────────
//     // Chart
//     // ─────────────────────────────────────
//     let chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         layout: root.verticalLayout,

//         panX: false,
//         panY: false,

//         wheelX: "none",
//         wheelY: "none",

//         paddingTop: 20,
//         // paddingBottom: 20,
//         paddingBottom: 45,
//         paddingLeft: 10,
//         paddingRight: 20,
//       })
//     );

//     // Native horizontal scroll support
//     chart.plotContainer.set("width", chartWidth);

//     const xRenderer = am5xy.AxisRendererX.new(root, {
//       // minGridDistance: 60,
//       minGridDistance: 90,
//       cellStartLocation: 0.15,
//       cellEndLocation: 0.85,
//     });

//     const xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         categoryField: "metricLabel",
//         renderer: xRenderer,
//       })
//     );

//     xAxis.data.setAll(chartData);

//     // ── FIX: Create one tooltip per label using an adapter so each label
//     //         shows its own full category text on hover. ──────────────────
//     xRenderer.labels.template.setAll({
//       paddingTop: 12,
//       oversizedBehavior: "truncate",
//       maxWidth: 110,
//       textAlign: "center",
//       centerX: am5.p50,
//       fontSize: 11,
//       interactive: true,
//       cursorOverStyle: "pointer",
//       // Attach a tooltip directly on the label template.
//       // {category} is the amCharts 5 data-field placeholder for the
//       // full (un-truncated) category value on a CategoryAxis label.
//       tooltipText: "{category}",
//     });

//     // ─────────────────────────────────────
//     // Y Axis
//     // ─────────────────────────────────────
//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     yAxis.get("renderer").labels.template.setAll({
//       paddingRight: 10,
//     });

//     // Remove B suffix completely
//     yAxis.get("renderer").labels.template.adapters.add("text", (text) => text);

//     // Axis title
//     yAxis.children.unshift(
//       am5.Label.new(root, {
//         text: "Values in Billions",
//         rotation: -90,
//         y: am5.p50,
//         centerX: am5.p50,
//         fontSize: 13,
//       })
//     );

//     localCompanies.forEach((comp, idx) => {
//       const color = BAR_COLORS[idx % BAR_COLORS.length];

//       const series = chart.series.push(
//         am5xy.ColumnSeries.new(root, {
//           name: comp.label,
//           xAxis,
//           yAxis,
//           valueYField: comp.label,
//           categoryXField: "metricLabel",

//           fill: am5.color(color),
//           stroke: am5.color(color),

//           clustered: true,
//         })
//       );

//       series.columns.template.setAll({
//         width: am5.percent(65),
//         tooltipText: "{name}\n{categoryX}\n{valueY}",
//       });

//       series.data.setAll(chartData);
//     });

//     chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         behavior: "none",
//       })
//     );

//     const legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,
//         width: am5.percent(100),

//         layout: root.gridLayout,

//         useDefaultMarker: true,

//         paddingTop: 20,
//         paddingBottom: 10,
//       })
//     );

//     // Prevent overlap
//     legend.itemContainers.template.setAll({
//       width: am5.percent(33),
//       paddingBottom: 8,
//       paddingTop: 8,
//     });

//     legend.labels.template.setAll({
//       // oversizedBehavior: "wrap",
//       maxWidth: 220,
//       fontSize: 12,
//       breakWords: true,
//     });

//     // Optional better spacing
//     legend.markerRectangles.template.setAll({
//       cornerRadiusTL: 4,
//       cornerRadiusTR: 4,
//       cornerRadiusBL: 4,
//       cornerRadiusBR: 4,
//     });

//     legend.data.setAll(chart.series.values);

//     return () => {
//       root.dispose();
//     };
//   }, [chartData, localCompanies]);

//   const toggleCompany = (comp) => {
//     setLocalCompanies((prev) => {
//       const exists = prev.find((c) => c.value === comp.value);
//       if (exists) {
//         return prev.filter((c) => c.value !== comp.value);
//       }
//       return mergeUniqueCompanies(prev, [comp]);
//     });
//   };

//   const applyMetricFilter = () => {
//     setUpdatingMetrics(true);
//     setTimeout(() => {
//       setLocalMetrics([...new Set(metricDraft)]);
//       setShowMetricFilter(false);
//       setUpdatingMetrics(false);
//     }, 500);
//   };

//   // Panel: companies shown inside filter card (show more/less)
//   const panelCompanies = showAllPanelCompanies
//     ? competitorOptions
//     : competitorOptions.slice(0, PANEL_SHOW_DEFAULT);

//   // Panel: metrics shown inside filter card (show more/less)
//   const panelMetrics = showAllPanelMetrics
//     ? availableMetrics
//     : availableMetrics.slice(0, PANEL_SHOW_DEFAULT);

//   // Selected company badges below filter row (show more/less)
//   const visibleSelectedCompanies = showAllSelectedCompanies
//     ? localCompanies
//     : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

//   if (!financialData.length) return null;

//   return (
//     <div className="container mt-4 heatmap_wrapper">
//       <h3 className="mb-3 heatmap_head">Financial Performance - Bar Chart</h3>

//       {/* ── Filter buttons row (matches heatmap button style) ── */}
//       <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
//         <button
//           // className="btn mt-4 ml-3 heatmap_filter_metrics"
//           className="btn mt-4 heatmap_filter_metrics"
//           onClick={() => {
//             setShowCompanyFilter((prev) => !prev);
//             setShowMetricFilter(false);
//           }}
//         >
//           Filter Companies
//         </button>

//         <button
//           className="btn mt-4 ml-3 heatmap_filter_metrics"
//           onClick={() => {
//             setMetricDraft(localMetrics);
//             setShowMetricFilter((prev) => !prev);
//             setShowCompanyFilter(false);
//           }}
//         >
//           Filter Metrics
//         </button>
//       </div>

//       {showCompanyFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Companies
//           </label>

//           <Select
//             isMulti
//             //   options={competitorOptions}
//             options={mergeUniqueCompanies(competitorOptions)}
//             value={localCompanies}
//             className="font13 search_competitors_select"
//             placeholder="Search companies..."
//             closeMenuOnSelect={false}
//             isClearable={false}
//             backspaceRemovesValue={false}
//             hideSelectedOptions={false}
//             components={{ Option: CheckboxOption }}
//             controlShouldRenderValue={false}
//             onChange={(list) => setLocalCompanies(list || [])}
//           />

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowCompanyFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localCompanies.length}
//           </small>
//         </div>
//       )}

//       {/* ── Metric filter panel (matches heatmap select_heatmap_card style) ── */}
//       {showMetricFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Metrics
//           </label>

//           <Select
//             isMulti
//             className="font13 search_competitors_select"
//             closeMenuOnSelect={false}
//             hideSelectedOptions={false}
//             controlShouldRenderValue={false}
//             options={groupedMetricOptions}
//             value={groupedMetricOptions
//               .flatMap((group) => group.options)
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Option: CheckboxOption,
//               MenuList: CollapsibleMenuList,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           />

//           {/* Show more / Show less inside panel */}
//           {availableMetrics.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelMetrics((prev) => !prev)}
//             >
//               {showAllPanelMetrics
//                 ? "Show Less"
//                 : `Show More (${
//                     availableMetrics.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-primary btn-sm select_heatmap_apply_btn"
//               onClick={applyMetricFilter}
//               disabled={metricDraft.length === 0 || updatingMetrics}
//             >
//               Apply
//             </button>
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowMetricFilter(false)}
//             >
//               Cancel
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {metricDraft.length}
//           </small>
//         </div>
//       )}

//       {updatingMetrics && (
//         <div className="mt-2 text-primary font14">Updating filters...</div>
//       )}

//       {/* ── Active selected company badges ── */}
//       {localCompanies.length > 0 && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Showing Companies
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             {visibleSelectedCompanies.map((comp) => (
//               <div
//                 key={comp.value}
//                 className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
//               >
//                 {comp.label}
//                 <span
//                   className="ml-2"
//                   style={{ cursor: "pointer", fontWeight: "bold" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   ×
//                 </span>
//               </div>
//             ))}
//           </div>

//           {/* Show more / Show less for active badges */}
//           {localCompanies.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
//             >
//               {showAllSelectedCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     localCompanies.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}
//         </div>
//       )}

//       <div
//         style={{
//           width: "100%",
//           overflowX: "auto",
//           overflowY: "hidden",
//           position: "relative",
//         }}
//       >
//         <div
//           ref={chartRef}
//           style={{
//             width: `${Math.max(chartData.length * 180, 1000)}px`,
//             minHeight: "420px",
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default GroupedBarChart;

// import React, {
//   useLayoutEffect,
//   useRef,
//   useState,
//   useEffect,
//   useMemo,
// } from "react";
// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import Select from "react-select";
// import { components } from "react-select";
// import APP_CONFIG from "../../config/appConfig";

// // ── Constants ─────────────────────────────────────────────────────────────────

// const MAX_DEFAULT_COMPANIES = 3;
// const MAX_DEFAULT_METRICS = 4;
// const PANEL_SHOW_DEFAULT = 5;

// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: 8 }}
//       />
//       {props.label}
//     </components.Option>
//   );
// };

// const mergeUniqueCompanies = (...lists) => {
//   const map = new Map();
//   lists.flat().forEach((c) => {
//     if (c && !map.has(c.value)) {
//       map.set(c.value, c);
//     }
//   });
//   return Array.from(map.values());
// };

// const buildGroupedMetricOptions = (availableMetrics) => {
//   return Object.entries(APP_CONFIG?.METRIC_GROUPS)
//     .map(([group, metrics]) => {
//       const options = metrics
//         .filter((metric) => availableMetrics.includes(metric))
//         .map((metric) => ({
//           label: formatMetricLabel(metric),
//           value: metric,
//         }));

//       return options.length
//         ? {
//             label: group,
//             options,
//           }
//         : null;
//     })
//     .filter(Boolean);
// };

// const CollapsibleMenuList = (props) => {
//   const { children, selectProps } = props;
//   const { collapsedGroups, setCollapsedGroups } = selectProps;

//   return (
//     <components.MenuList {...props}>
//       {React.Children.map(children, (group) => {
//         if (!group?.props?.data) return group;

//         const label = group.props.data.label;
//         const isCollapsed = collapsedGroups?.includes(label);

//         return (
//           <div>
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setCollapsedGroups((prev) =>
//                   isCollapsed
//                     ? prev.filter((g) => g !== label)
//                     : [...prev, label]
//                 );
//               }}
//               style={{
//                 cursor: "pointer",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 padding: "8px 12px",
//                 background: "#f8f9fa",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               {isCollapsed ? "▶" : "▼"} {label}
//             </div>
//             {!isCollapsed && group}
//           </div>
//         );
//       })}
//     </components.MenuList>
//   );
// };

// const BAR_COLORS = [
//   0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
//   0xd35400,
// ];

// const formatMetricLabel = (metric) =>
//   APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

// const deriveAvailableMetrics = (financialData) => {
//   if (!financialData?.length) return [];

//   const metricSet = new Set();
//   financialData.forEach((company) => {
//     company.metrics?.forEach((m) => {
//       if (m.metric && m.value !== null && m.value !== undefined) {
//         metricSet.add(m.metric);
//       }
//     });
//   });

//   return Array.from(metricSet);
// };

// const buildChartData = (financialData, activeCompanies, activeMetrics) => {
//   if (
//     !financialData?.length ||
//     !activeCompanies?.length ||
//     !activeMetrics?.length
//   )
//     return [];

//   return activeMetrics.map((metric) => {
//     const row = { metricLabel: formatMetricLabel(metric) };
//     activeCompanies.forEach((comp) => {
//       const compData = financialData.find(
//         (fd) => fd.vendor_company_id === comp.value
//       );
//       const metricEntry = compData?.metrics?.find((m) => m.metric === metric);
//       row[comp.label] = metricEntry?.value ?? 0;
//     });
//     return row;
//   });
// };

// const GroupedBarChart = ({ financialData = [], competitorOptions = [] }) => {
//   const chartRef = useRef(null);
//   // Ref to the lightweight DOM tooltip element
//   const domTooltipRef = useRef(null);

//   const availableMetrics = useMemo(
//     () => deriveAvailableMetrics(financialData),
//     [financialData]
//   );

//   const groupedMetricOptions = useMemo(
//     () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
//     [availableMetrics]
//   );

//   const [localCompanies, setLocalCompanies] = useState(() =>
//     competitorOptions.slice(0, MAX_DEFAULT_COMPANIES)
//   );

//   const [localMetrics, setLocalMetrics] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   const [metricDraft, setMetricDraft] = useState(() =>
//     [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
//   );

//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);
//   const [showMetricFilter, setShowMetricFilter] = useState(false);
//   const [updatingMetrics, setUpdatingMetrics] = useState(false);
//   const [showAllPanelCompanies, setShowAllPanelCompanies] = useState(false);
//   const [showAllPanelMetrics, setShowAllPanelMetrics] = useState(false);
//   const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
//     useState(false);
//   const [collapsedGroups, setCollapsedGroups] = useState(
//     Object.keys(APP_CONFIG?.METRIC_GROUPS)
//   );

//   useEffect(() => {
//     if (!competitorOptions.length) return;
//     setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
//   }, [competitorOptions]);

//   useEffect(() => {
//     const unique = [...new Set(availableMetrics)];
//     const defaults = unique.slice(0, MAX_DEFAULT_METRICS);
//     setLocalMetrics(defaults);
//     setMetricDraft(defaults);
//   }, [availableMetrics]);

//   // ── Mount a single DOM tooltip div for the lifetime of this component ────
//   useEffect(() => {
//     const tip = document.createElement("div");
//     tip.style.cssText = `
//       position: fixed;
//       background: rgba(0, 0, 0, 0.76);
//       color: #fff;
//       padding: 5px 10px;
//       border-radius: 4px;
//       font-size: 12px;
//       line-height: 1.45;
//       pointer-events: none;
//       white-space: normal;
//       word-break: break-word;
//       max-width: 240px;
//       z-index: 99999;
//       display: none;
//       box-shadow: 0 2px 8px rgba(0,0,0,0.25);
//     `;
//     document.body.appendChild(tip);
//     domTooltipRef.current = tip;

//     return () => {
//       tip.remove();
//       domTooltipRef.current = null;
//     };
//   }, []);

//   const chartData = useMemo(
//     () => buildChartData(financialData, localCompanies, localMetrics),
//     [financialData, localCompanies, localMetrics]
//   );

//   useLayoutEffect(() => {
//     if (!chartData.length || !localCompanies.length) return;

//     const tip = domTooltipRef.current;

//     let root = am5.Root.new(chartRef.current);
//     root._logo.dispose();
//     root.setThemes([am5themes_Animated.new(root)]);

//     const categoryWidth = Math.max(140, localCompanies.length * 45);
//     const chartWidth = Math.max(
//       chartData.length * categoryWidth,
//       chartRef.current?.offsetWidth || 1200
//     );

//     let chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         layout: root.verticalLayout,
//         panX: false,
//         panY: false,
//         wheelX: "none",
//         wheelY: "none",
//         paddingTop: 20,
//         paddingBottom: 45,
//         paddingLeft: 10,
//         paddingRight: 20,
//       })
//     );

//     chart.plotContainer.set("width", chartWidth);

//     const xRenderer = am5xy.AxisRendererX.new(root, {
//       minGridDistance: 90,
//       cellStartLocation: 0.15,
//       cellEndLocation: 0.85,
//     });

//     const xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         categoryField: "metricLabel",
//         renderer: xRenderer,
//       })
//     );

//     xAxis.data.setAll(chartData);

//     // ── X-axis label template ─────────────────────────────────────────────
//     xRenderer.labels.template.setAll({
//       paddingTop: 12,
//       oversizedBehavior: "truncate",
//       maxWidth: 110,
//       textAlign: "center",
//       centerX: am5.p50,
//       fontSize: 11,
//       interactive: true,
//       cursorOverStyle: "pointer",
//     });

//     // ── DOM tooltip wiring via amCharts sprite events ─────────────────────
//     // "pointerover" — show tooltip with the full (non-truncated) category
//     xRenderer.labels.template.events.on("pointerover", function (ev) {
//       if (!tip) return;
//       // Pull the full category string from the dataItem on the label sprite
//       const fullLabel =
//         ev.target?.dataItem?.get("category") ||
//         ev.target?.dataItem?.dataContext?.metricLabel ||
//         "";
//       if (!fullLabel) return;
//       tip.textContent = fullLabel;
//       tip.style.display = "block";
//     });

//     // "pointermove" — track the cursor so the tooltip follows the mouse
//     xRenderer.labels.template.events.on("pointermove", function (ev) {
//       if (!tip || tip.style.display === "none") return;
//       const native = ev.originalEvent;
//       if (!native) return;
//       const cx = native.clientX;
//       const cy = native.clientY;
//       const tipW = tip.offsetWidth;
//       const vw = window.innerWidth;
//       // Shift left if the tooltip would overflow the right edge
//       tip.style.left = Math.min(cx + 14, vw - tipW - 8) + "px";
//       tip.style.top = cy - 40 + "px";
//     });

//     // "pointerout" — hide tooltip
//     xRenderer.labels.template.events.on("pointerout", function () {
//       if (!tip) return;
//       tip.style.display = "none";
//     });

//     // ─────────────────────────────────────
//     // Y Axis
//     // ─────────────────────────────────────
//     const yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     yAxis.get("renderer").labels.template.setAll({
//       paddingRight: 10,
//     });

//     yAxis.get("renderer").labels.template.adapters.add("text", (text) => text);

//     yAxis.children.unshift(
//       am5.Label.new(root, {
//         text: "Values in Billions",
//         rotation: -90,
//         y: am5.p50,
//         centerX: am5.p50,
//         fontSize: 13,
//       })
//     );

//     localCompanies.forEach((comp, idx) => {
//       const color = BAR_COLORS[idx % BAR_COLORS.length];

//       const series = chart.series.push(
//         am5xy.ColumnSeries.new(root, {
//           name: comp.label,
//           xAxis,
//           yAxis,
//           valueYField: comp.label,
//           categoryXField: "metricLabel",
//           fill: am5.color(color),
//           stroke: am5.color(color),
//           clustered: true,
//         })
//       );

//       series.columns.template.setAll({
//         width: am5.percent(65),
//         tooltipText: "{name}\n{categoryX}\n{valueY}",
//       });

//       series.data.setAll(chartData);
//     });

//     chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         behavior: "none",
//       })
//     );

//     const legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,
//         width: am5.percent(100),
//         layout: root.gridLayout,
//         useDefaultMarker: true,
//         paddingTop: 20,
//         paddingBottom: 10,
//       })
//     );

//     legend.itemContainers.template.setAll({
//       width: am5.percent(33),
//       paddingBottom: 8,
//       paddingTop: 8,
//     });

//     legend.labels.template.setAll({
//       maxWidth: 220,
//       fontSize: 12,
//       breakWords: true,
//     });

//     legend.markerRectangles.template.setAll({
//       cornerRadiusTL: 4,
//       cornerRadiusTR: 4,
//       cornerRadiusBL: 4,
//       cornerRadiusBR: 4,
//     });

//     legend.data.setAll(chart.series.values);

//     return () => {
//       // Always hide the DOM tooltip when the chart re-renders or unmounts
//       if (tip) tip.style.display = "none";
//       root.dispose();
//     };
//   }, [chartData, localCompanies]);

//   const toggleCompany = (comp) => {
//     setLocalCompanies((prev) => {
//       const exists = prev.find((c) => c.value === comp.value);
//       if (exists) {
//         return prev.filter((c) => c.value !== comp.value);
//       }
//       return mergeUniqueCompanies(prev, [comp]);
//     });
//   };

//   const applyMetricFilter = () => {
//     setUpdatingMetrics(true);
//     setTimeout(() => {
//       setLocalMetrics([...new Set(metricDraft)]);
//       setShowMetricFilter(false);
//       setUpdatingMetrics(false);
//     }, 500);
//   };

//   const panelCompanies = showAllPanelCompanies
//     ? competitorOptions
//     : competitorOptions.slice(0, PANEL_SHOW_DEFAULT);

//   const panelMetrics = showAllPanelMetrics
//     ? availableMetrics
//     : availableMetrics.slice(0, PANEL_SHOW_DEFAULT);

//   const visibleSelectedCompanies = showAllSelectedCompanies
//     ? localCompanies
//     : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

//   if (!financialData.length) return null;

//   return (
//     <div className="container mt-4 heatmap_wrapper">
//       <h3 className="mb-3 heatmap_head">Financial Performance - Bar Chart</h3>

//       {/* ── Filter buttons row ── */}
//       <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
//         <button
//           className="btn mt-4 heatmap_filter_metrics"
//           onClick={() => {
//             setShowCompanyFilter((prev) => !prev);
//             setShowMetricFilter(false);
//           }}
//         >
//           Filter Companies
//         </button>

//         <button
//           className="btn mt-4 ml-3 heatmap_filter_metrics"
//           onClick={() => {
//             setMetricDraft(localMetrics);
//             setShowMetricFilter((prev) => !prev);
//             setShowCompanyFilter(false);
//           }}
//         >
//           Filter Metrics
//         </button>
//       </div>

//       {showCompanyFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Companies
//           </label>

//           <Select
//             isMulti
//             options={mergeUniqueCompanies(competitorOptions)}
//             value={localCompanies}
//             className="font13 search_competitors_select"
//             placeholder="Search companies..."
//             closeMenuOnSelect={false}
//             isClearable={false}
//             backspaceRemovesValue={false}
//             hideSelectedOptions={false}
//             components={{ Option: CheckboxOption }}
//             controlShouldRenderValue={false}
//             onChange={(list) => setLocalCompanies(list || [])}
//           />

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowCompanyFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localCompanies.length}
//           </small>
//         </div>
//       )}

//       {showMetricFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font13 fw-medium mb-2 select_heatmap_card_label">
//             Select Metrics
//           </label>

//           <Select
//             isMulti
//             className="font13 search_competitors_select"
//             closeMenuOnSelect={false}
//             hideSelectedOptions={false}
//             controlShouldRenderValue={false}
//             options={groupedMetricOptions}
//             value={groupedMetricOptions
//               .flatMap((group) => group.options)
//               .filter((opt) => metricDraft.includes(opt.value))}
//             onChange={(list) =>
//               setMetricDraft([
//                 ...new Set((list || []).map((item) => item.value)),
//               ])
//             }
//             components={{
//               Option: CheckboxOption,
//               MenuList: CollapsibleMenuList,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           />

//           {availableMetrics.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllPanelMetrics((prev) => !prev)}
//             >
//               {showAllPanelMetrics
//                 ? "Show Less"
//                 : `Show More (${
//                     availableMetrics.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-primary btn-sm select_heatmap_apply_btn"
//               onClick={applyMetricFilter}
//               disabled={metricDraft.length === 0 || updatingMetrics}
//             >
//               Apply
//             </button>
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowMetricFilter(false)}
//             >
//               Cancel
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {metricDraft.length}
//           </small>
//         </div>
//       )}

//       {updatingMetrics && (
//         <div className="mt-2 text-primary font14">Updating filters...</div>
//       )}

//       {localCompanies.length > 0 && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Showing Companies
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             {visibleSelectedCompanies.map((comp) => (
//               <div
//                 key={comp.value}
//                 className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
//               >
//                 {comp.label}
//                 <span
//                   className="ml-2"
//                   style={{ cursor: "pointer", fontWeight: "bold" }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   ×
//                 </span>
//               </div>
//             ))}
//           </div>

//           {localCompanies.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
//             >
//               {showAllSelectedCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     localCompanies.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}
//         </div>
//       )}

//       <div
//         style={{
//           width: "100%",
//           overflowX: "auto",
//           overflowY: "hidden",
//           position: "relative",
//         }}
//       >
//         <div
//           ref={chartRef}
//           style={{
//             width: `${Math.max(chartData.length * 180, 1000)}px`,
//             minHeight: "420px",
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default GroupedBarChart;

import React, {
  useLayoutEffect,
  useRef,
  useState,
  useEffect,
  useMemo,
} from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as FeatherIcon from "react-feather";
import Select from "react-select";
import { components } from "react-select";
import APP_CONFIG from "../../config/appConfig";

// ── Constants ─────────────────────────────────────────────────────────────────

const MAX_DEFAULT_COMPANIES = 3;
const MAX_DEFAULT_METRICS = 4;
const PANEL_SHOW_DEFAULT = 5;

const DEFAULT_METRICS = [
  "IQ_TOTAL_REV",
  "IQ_GP",
  "IQ_EBITDA",
  "IQ_EBIT",
  "IQ_NI",
  "IQ_BASIC_EPS_INCL",
  "IQ_TOTAL_ASSETS",
  "IQ_TOTAL_CAP",
];

const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      {props.label}
    </components.Option>
  );
};

const mergeUniqueCompanies = (...lists) => {
  const map = new Map();
  lists.flat().forEach((c) => {
    if (c && !map.has(c.value)) {
      map.set(c.value, c);
    }
  });
  return Array.from(map.values());
};

const buildGroupedMetricOptions = (availableMetrics) => {
  return Object.entries(APP_CONFIG?.METRIC_GROUPS)
    .map(([group, metrics]) => {
      const options = metrics
        .filter((metric) => availableMetrics.includes(metric))
        .map((metric) => ({
          label: formatMetricLabel(metric),
          value: metric,
        }));

      return options.length
        ? {
            label: group,
            options,
          }
        : null;
    })
    .filter(Boolean);
};

const CollapsibleMenuList = (props) => {
  const { children, selectProps } = props;
  const { collapsedGroups, setCollapsedGroups } = selectProps;

  return (
    <components.MenuList {...props}>
      {React.Children.map(children, (group) => {
        if (!group?.props?.data) return group;

        const label = group.props.data.label;
        const isCollapsed = collapsedGroups?.includes(label);

        return (
          <div>
            <div
              onClick={(e) => {
                e.stopPropagation();
                setCollapsedGroups((prev) =>
                  isCollapsed
                    ? prev.filter((g) => g !== label)
                    : [...prev, label]
                );
              }}
              style={{
                cursor: "pointer",
                fontWeight: 600,
                fontSize: 13,
                padding: "8px 12px",
                background: "#f8f9fa",
                borderBottom: "1px solid #eee",
              }}
            >
              {isCollapsed ? (
                <FeatherIcon.ChevronRight width={16} className="" />
              ) : (
                <FeatherIcon.ChevronDown width={16} className="" />
              )}{" "}
              {label}
            </div>
            {!isCollapsed && group}
          </div>
        );
      })}
    </components.MenuList>
  );
};

const BAR_COLORS = [
  0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
  0xd35400,
];

const formatMetricLabel = (metric) =>
  APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

const deriveAvailableMetrics = (financialData) => {
  if (!financialData?.length) return [];
  const metricSet = new Set();
  financialData.forEach((company) => {
    company.metrics?.forEach((m) => {
      if (m.metric && m.value !== null && m.value !== undefined) {
        metricSet.add(m.metric);
      }
    });
  });
  return Array.from(metricSet);
};

const buildChartData = (financialData, activeCompanies, activeMetrics) => {
  if (
    !financialData?.length ||
    !activeCompanies?.length ||
    !activeMetrics?.length
  )
    return [];

  return activeMetrics.map((metric) => {
    const row = { metricLabel: formatMetricLabel(metric) };
    activeCompanies.forEach((comp) => {
      const compData = financialData.find(
        (fd) => fd.vendor_company_id === comp.value
      );
      const metricEntry = compData?.metrics?.find((m) => m.metric === metric);
      row[comp.label] = metricEntry?.value ?? 0;
    });
    return row;
  });
};

// ── Helpers ───────────────────────────────────────────────────────────────────

/**
 * amCharts stores the full (un-truncated) text in the SVG element's
 * aria-label OR as the last child tspan that has no display truncation.
 * We also accept a fallback map keyed by truncated text.
 */
const getFullLabelText = (el, fallbackMap) => {
  // 1. aria-label set by amCharts when oversizedBehavior = "truncate"
  const aria = el.getAttribute("aria-label");
  if (aria) return aria;

  // 2. Walk child <tspan> nodes – the last one often holds the full string
  //    before amCharts overwrites the visible text with "…"
  //    Instead, use our fallback map built from chartData
  const visibleText = el.textContent?.trim();
  if (visibleText && fallbackMap) {
    // Try exact match first
    if (fallbackMap[visibleText]) return fallbackMap[visibleText];
    // Try prefix match (handles "Total Dividends ..." → full label)
    const prefix = visibleText.replace(/[.\s]+$/, "").toLowerCase();
    const match = Object.keys(fallbackMap).find((k) =>
      k.toLowerCase().startsWith(prefix)
    );
    if (match) return fallbackMap[match];
  }

  return visibleText || "";
};

/**
 * Attach native mouse listeners to every SVG <text> inside the x-axis
 * label group, and observe for new ones via MutationObserver.
 * Returns a cleanup function.
 */
const attachLabelTooltips = (chartContainer, tip, fallbackMap) => {
  if (!chartContainer || !tip) return () => {};

  const bound = new Set();
  const observers = [];

  const onEnter = (el) => (e) => {
    const full = getFullLabelText(el, fallbackMap);
    if (!full) return;
    tip.textContent = full;
    tip.style.display = "block";
    positionTip(e);
  };
  const onMove = (e) => positionTip(e);
  const onLeave = () => {
    tip.style.display = "none";
  };

  const positionTip = (e) => {
    const vw = window.innerWidth;
    const tipW = tip.offsetWidth || 200;
    const x = Math.min(e.clientX + 14, vw - tipW - 8);
    const y = e.clientY - 40;
    tip.style.left = x + "px";
    tip.style.top = y + "px";
  };

  const bindEl = (el) => {
    if (bound.has(el)) return;
    // Must explicitly enable pointer-events on SVG text nodes
    el.style.pointerEvents = "all";
    el.style.cursor = "pointer";
    el.addEventListener("mouseenter", onEnter(el));
    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    bound.add(el);
  };

  // Query & bind all existing label <text> elements inside the x-axis area.
  // amCharts places x-axis labels in an <svg> inside chartContainer.
  // We target every <text> that is NOT a y-axis label by filtering on
  // their vertical position (they sit near the bottom of the SVG).
  const bindAll = () => {
    const svgEl = chartContainer.querySelector("svg");
    if (!svgEl) return;
    const svgH = svgEl.getBoundingClientRect().height;
    svgEl.querySelectorAll("text").forEach((el) => {
      const rect = el.getBoundingClientRect();
      const svgRect = svgEl.getBoundingClientRect();
      // X-axis labels are in the lower ~20% of the SVG
      if (rect.top - svgRect.top > svgH * 0.75) {
        bindEl(el);
      }
    });
  };

  // Run once after a short delay (amCharts finishes rendering asynchronously)
  const t1 = setTimeout(bindAll, 300);
  const t2 = setTimeout(bindAll, 800); // second pass for animated entries

  // Also watch for DOM changes (e.g. after filter updates)
  const svgEl = chartContainer.querySelector("svg");
  if (svgEl) {
    const mo = new MutationObserver(() => bindAll());
    mo.observe(svgEl, { childList: true, subtree: true });
    observers.push(mo);
  }

  return () => {
    clearTimeout(t1);
    clearTimeout(t2);
    observers.forEach((o) => o.disconnect());
    tip.style.display = "none";
  };
};

// ─────────────────────────────────────────────────────────────────────────────

const GroupedBarChart = ({ financialData = [], competitorOptions = [] }) => {
  const chartRef = useRef(null);
  const domTooltipRef = useRef(null);

  const availableMetrics = useMemo(
    () => deriveAvailableMetrics(financialData),
    [financialData]
  );

  const groupedMetricOptions = useMemo(
    () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
    [availableMetrics]
  );

  const [localCompanies, setLocalCompanies] = useState(() =>
    competitorOptions.slice(0, MAX_DEFAULT_COMPANIES)
  );
  // const [localMetrics, setLocalMetrics] = useState(() =>
  //   [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
  // );
  // const [metricDraft, setMetricDraft] = useState(() =>
  //   [...new Set(availableMetrics)].slice(0, MAX_DEFAULT_METRICS)
  // );

  const getDefaultMetrics = (metrics) =>
    DEFAULT_METRICS.filter((metric) => metrics.includes(metric));

  const [localMetrics, setLocalMetrics] = useState(() =>
    getDefaultMetrics([...new Set(availableMetrics)])
  );

  const [metricDraft, setMetricDraft] = useState(() =>
    getDefaultMetrics([...new Set(availableMetrics)])
  );

  const sortedGroupedMetricOptions = useMemo(() => {
    return groupedMetricOptions.map((group) => {
      const selected = [];
      const unselected = [];

      group.options.forEach((option) => {
        if (metricDraft.includes(option.value)) {
          selected.push(option);
        } else {
          unselected.push(option);
        }
      });

      return {
        ...group,
        options: [...selected, ...unselected],
      };
    });
  }, [groupedMetricOptions, metricDraft]);

  const [showCompanyFilter, setShowCompanyFilter] = useState(false);
  const [showMetricFilter, setShowMetricFilter] = useState(false);
  const [updatingMetrics, setUpdatingMetrics] = useState(false);

  const [showAllPanelCompanies, setShowAllPanelCompanies] = useState(false);
  const [showAllPanelMetrics, setShowAllPanelMetrics] = useState(false);
  const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
    useState(false);

  const [collapsedGroups, setCollapsedGroups] = useState(
    Object.keys(APP_CONFIG?.METRIC_GROUPS)
  );
  const [legendExpanded, setLegendExpanded] = useState(false);
  useEffect(() => {
    if (!competitorOptions.length) return;
    setLocalCompanies(competitorOptions.slice(0, MAX_DEFAULT_COMPANIES));
  }, [competitorOptions]);

  // useEffect(() => {
  //   const unique = [...new Set(availableMetrics)];
  //   const defaults = unique.slice(0, MAX_DEFAULT_METRICS);
  //   setLocalMetrics(defaults);
  //   setMetricDraft(defaults);
  // }, [availableMetrics]);

  useEffect(() => {
    const unique = [...new Set(availableMetrics)];

    const defaults = getDefaultMetrics(unique);

    setLocalMetrics(defaults);
    setMetricDraft(defaults);
  }, [availableMetrics]);

  // ── Create one DOM tooltip for the lifetime of this component ────────────
  useEffect(() => {
    const tip = document.createElement("div");
    tip.style.cssText = `
      position: fixed;
      background: rgba(0,0,0,0.76);
      color: #fff;
      padding: 5px 10px;
      border-radius: 4px;
      font-size: 12px;
      line-height: 1.45;
      pointer-events: none;
      white-space: normal;
      word-break: break-word;
      max-width: 240px;
      z-index: 99999;
      display: none;
      box-shadow: 0 2px 8px rgba(0,0,0,0.25);
    `;
    document.body.appendChild(tip);
    domTooltipRef.current = tip;
    return () => {
      tip.remove();
      domTooltipRef.current = null;
    };
  }, []);

  const chartData = useMemo(
    () => buildChartData(financialData, localCompanies, localMetrics),
    [financialData, localCompanies, localMetrics]
  );

  // Build a lookup: truncated-or-full label → full label
  // so the DOM tooltip can resolve what the user is hovering.
  const labelFallbackMap = useMemo(() => {
    const map = {};
    chartData.forEach((row) => {
      if (row.metricLabel) map[row.metricLabel] = row.metricLabel;
    });
    return map;
  }, [chartData]);

  useLayoutEffect(() => {
    if (!chartData.length || !localCompanies.length) return;

    const tip = domTooltipRef.current;

    let root = am5.Root.new(chartRef.current);
    root._logo.dispose();
    root.setThemes([am5themes_Animated.new(root)]);

    // const categoryWidth = Math.max(140, localCompanies.length * 45);
    const categoryWidth = Math.max(220, localCompanies.length * 60);
    const chartWidth = Math.max(
      chartData.length * categoryWidth,
      chartRef.current?.offsetWidth || 1200
    );

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout,
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        paddingTop: 20,
        paddingBottom: 45,
        paddingLeft: 10,
        paddingRight: 20,
      })
    );

    chart.plotContainer.set("width", chartWidth);

    const xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 90,
      cellStartLocation: 0.15,
      cellEndLocation: 0.85,
    });

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "metricLabel",
        renderer: xRenderer,
      })
    );

    xAxis.data.setAll(chartData);

    // xRenderer.labels.template.setAll({
    //   paddingTop: 12,
    //   oversizedBehavior: "truncate",
    //   maxWidth: 110,
    //   textAlign: "center",
    //   centerX: am5.p50,
    //   fontSize: 11,
    //   interactive: true,
    //   cursorOverStyle: "pointer",
    // });

    xRenderer.labels.template.setAll({
      paddingTop: 12,
      oversizedBehavior: "none", // remove truncation
      textAlign: "center",
      centerX: am5.p50,
      centerY: am5.p0,
      fontSize: 11,
      interactive: true,
      cursorOverStyle: "pointer",
      oversizedBehavior: "wrap",
      maxWidth: 160, // increase label width
      width: 160,
      multiline: true,
      populateText: true,
    });

    // ─────────────────────────────────────
    // Y Axis
    // ─────────────────────────────────────
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0,
      })
    );

    yAxis
      .get("renderer")
      .labels.template.setAll({ paddingRight: 10, fontSize: 12 });
    yAxis.get("renderer").labels.template.adapters.add("text", (text) => text);

    yAxis.children.unshift(
      am5.Label.new(root, {
        text: "Values in Millions",
        rotation: -90,
        y: am5.p50,
        centerX: am5.p50,
        fontSize: 13,
      })
    );

    // localCompanies.forEach((comp, idx) => {
    //   const color = BAR_COLORS[idx % BAR_COLORS.length];
    //   const series = chart.series.push(
    //     am5xy.ColumnSeries.new(root, {
    //       name: comp.label,
    //       xAxis,
    //       yAxis,
    //       valueYField: comp.label,
    //       categoryXField: "metricLabel",
    //       fill: am5.color(color),
    //       stroke: am5.color(color),
    //       clustered: true,
    //     })
    //   );
    //   series.columns.template.setAll({
    //     width: am5.percent(65),
    //     tooltipText: "{name}\n{categoryX}\n{valueY}",
    //   });
    //   series.data.setAll(chartData);
    // });

    localCompanies.forEach((comp, idx) => {
      const color = BAR_COLORS[idx % BAR_COLORS.length];

      const tooltip = am5.Tooltip.new(root, {});

      tooltip.label.setAll({
        fontSize: 12,
      });

      const series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: comp.label,
          xAxis,
          yAxis,
          valueYField: comp.label,
          categoryXField: "metricLabel",
          fill: am5.color(color),
          stroke: am5.color(color),
          clustered: true,
        })
      );

      series.columns.template.setAll({
        width: am5.percent(65),
        tooltipText: "{name}\n{categoryX}\n{valueY}",
        tooltip,
      });

      series.data.setAll(chartData);
    });

    chart.set("cursor", am5xy.XYCursor.new(root, { behavior: "none" }));

    // const legend = chart.children.push(
    //   am5.Legend.new(root, {
    //     centerX: am5.p50,
    //     x: am5.p50,
    //     width: am5.percent(100),
    //     layout: root.gridLayout,
    //     useDefaultMarker: true,
    //     paddingTop: 20,
    //     paddingBottom: 10,
    //   })
    // );

    // legend.itemContainers.template.setAll({
    //   width: am5.percent(33),
    //   paddingBottom: 8,
    //   paddingTop: 8,
    // });
    // legend.labels.template.setAll({
    //   maxWidth: 220,
    //   fontSize: 12,
    //   breakWords: true,
    // });
    // legend.markerRectangles.template.setAll({
    //   cornerRadiusTL: 4,
    //   cornerRadiusTR: 4,
    //   cornerRadiusBL: 4,
    //   cornerRadiusBR: 4,
    // });
    // legend.data.setAll(chart.series.values);

    const LEGEND_ITEMS_PER_LINE = 3;
    const MAX_LEGEND_LINES = 1;
    const MAX_VISIBLE_LEGEND_ITEMS = LEGEND_ITEMS_PER_LINE * MAX_LEGEND_LINES;

    const allSeries = chart.series.values;
    const visibleSeries = legendExpanded
      ? allSeries
      : allSeries.slice(0, MAX_VISIBLE_LEGEND_ITEMS);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50,
        width: am5.percent(100),
        layout: root.gridLayout,
        useDefaultMarker: true,
        paddingTop: 20,
        paddingBottom: 10,
      })
    );

    legend.itemContainers.template.setAll({
      width: am5.percent(33),
      paddingBottom: 8,
      paddingTop: 8,
    });
    legend.labels.template.setAll({
      maxWidth: 220,
      fontSize: 12,
      breakWords: true,
    });
    legend.markerRectangles.template.setAll({
      cornerRadiusTL: 4,
      cornerRadiusTR: 4,
      cornerRadiusBL: 4,
      cornerRadiusBR: 4,
    });
    legend.data.setAll(visibleSeries);

    // ── Attach DOM tooltip to actual SVG label elements ───────────────────
    // Wait for amCharts to finish its async render then wire native listeners.
    const cleanupTooltips = attachLabelTooltips(
      chartRef.current,
      tip,
      labelFallbackMap
    );

    return () => {
      cleanupTooltips();
      root.dispose();
    };
  }, [chartData, localCompanies, labelFallbackMap, legendExpanded]);

  const toggleCompany = (comp) => {
    setLocalCompanies((prev) => {
      const exists = prev.find((c) => c.value === comp.value);
      if (exists) return prev.filter((c) => c.value !== comp.value);
      return mergeUniqueCompanies(prev, [comp]);
    });
  };

  const applyMetricFilter = () => {
    setUpdatingMetrics(true);
    setTimeout(() => {
      setLocalMetrics([...new Set(metricDraft)]);
      setShowMetricFilter(false);
      setUpdatingMetrics(false);
    }, 500);
  };

  const panelCompanies = showAllPanelCompanies
    ? competitorOptions
    : competitorOptions.slice(0, PANEL_SHOW_DEFAULT);

  const panelMetrics = showAllPanelMetrics
    ? availableMetrics
    : availableMetrics.slice(0, PANEL_SHOW_DEFAULT);

  const visibleSelectedCompanies = showAllSelectedCompanies
    ? localCompanies
    : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

  if (!financialData.length) return null;

  return (
    <div className="container heatmap_wrapper">
      <h3 className="heatmap_head mb-0">Financial Performance - Bar Chart</h3>

      {/* ── Filter buttons row ── */}
      <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
        <button
          className="btn mt-2 heatmap_filter_metrics"
          onClick={() => {
            setShowCompanyFilter((prev) => !prev);
            setShowMetricFilter(false);
          }}
        >
          Filter Companies
        </button>

        <button
          className="btn mt-2 ml-3 heatmap_filter_metrics"
          onClick={() => {
            setMetricDraft(localMetrics);
            setShowMetricFilter((prev) => !prev);
            setShowCompanyFilter(false);
          }}
        >
          Filter Metrics
        </button>
      </div>

      {showCompanyFilter && (
        <div className="card p-3 mt-3 select_heatmap_card">
          <label className="font13 fw-medium mb-2 select_heatmap_card_label">
            Select Companies
          </label>
          <Select
            isMulti
            options={mergeUniqueCompanies(competitorOptions)}
            value={localCompanies}
            className="font13 search_competitors_select"
            styles={APP_CONFIG?.CUSTOM_SELECT_STYLES}
            placeholder="Search companies..."
            closeMenuOnSelect={false}
            isClearable={false}
            backspaceRemovesValue={false}
            hideSelectedOptions={false}
            components={{ Option: CheckboxOption }}
            controlShouldRenderValue={false}
            onChange={(list) => setLocalCompanies(list || [])}
          />
          <div className="mt-3 select_heatmap_apply_block">
            <button
              className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
              onClick={() => setShowCompanyFilter(false)}
            >
              Close
            </button>
          </div>
          <small className="text-muted mt-2">
            Selected: {localCompanies.length}
          </small>
        </div>
      )}

      {showMetricFilter && (
        <div className="card p-3 mt-3 select_heatmap_card">
          <label className="font13 fw-medium mb-2 select_heatmap_card_label">
            Select Metrics
          </label>
          {/* <Select
            isMulti
            className="font13 search_competitors_select"
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
            options={groupedMetricOptions}
            value={groupedMetricOptions
              .flatMap((group) => group.options)
              .filter((opt) => metricDraft.includes(opt.value))}
            onChange={(list) =>
              setMetricDraft([
                ...new Set((list || []).map((item) => item.value)),
              ])
            }
            components={{
              Option: CheckboxOption,
              MenuList: CollapsibleMenuList,
            }}
            collapsedGroups={collapsedGroups}
            setCollapsedGroups={setCollapsedGroups}
          /> */}

          <Select
            isMulti
            className="font13 search_competitors_select"
            styles={APP_CONFIG?.CUSTOM_SELECT_STYLES}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
            options={sortedGroupedMetricOptions}
            value={sortedGroupedMetricOptions
              .flatMap((group) => group.options)
              .filter((opt) => metricDraft.includes(opt.value))}
            onChange={(list) =>
              setMetricDraft([
                ...new Set((list || []).map((item) => item.value)),
              ])
            }
            components={{
              Option: CheckboxOption,
              MenuList: CollapsibleMenuList,
            }}
            collapsedGroups={collapsedGroups}
            setCollapsedGroups={setCollapsedGroups}
          />

          {availableMetrics.length > PANEL_SHOW_DEFAULT && (
            <button
              className="btn p-0 mt-1 show_more_finacial"
              onClick={() => setShowAllPanelMetrics((prev) => !prev)}
            >
              {showAllPanelMetrics
                ? "Show Less"
                : `Show More (${
                    availableMetrics.length - PANEL_SHOW_DEFAULT
                  } more)`}
            </button>
          )}
          <div className="mt-3 select_heatmap_apply_block">
            <button
              className="btn btn-primary btn-sm select_heatmap_apply_btn"
              onClick={applyMetricFilter}
              disabled={metricDraft.length === 0 || updatingMetrics}
            >
              Apply
            </button>
            <button
              className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
              onClick={() => setShowMetricFilter(false)}
            >
              Cancel
            </button>
          </div>
          <small className="text-muted mt-2">
            Selected: {metricDraft.length}
          </small>
        </div>
      )}

      {updatingMetrics && (
        <div className="mt-2 text-primary font14">Updating filters...</div>
      )}

      {localCompanies.length > 0 && (
        <div className="mt-2 selected_companies_block">
          <label className="form-label fw-medium selected_companies_lable">
            Showing Companies
          </label>
          <div className="d-flex flex-wrap selected_companies_tags">
            {visibleSelectedCompanies.map((comp) => (
              <div
                key={comp.value}
                className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
              >
                {comp.label}
                <span
                  className="ml-2"
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={() => toggleCompany(comp)}
                >
                  ×
                </span>
              </div>
            ))}
          </div>
          {localCompanies.length > PANEL_SHOW_DEFAULT && (
            <button
              className="btn p-0 mt-1 show_more_finacial"
              onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
            >
              {showAllSelectedCompanies
                ? "Show Less"
                : `Show More (${
                    localCompanies.length - PANEL_SHOW_DEFAULT
                  } more)`}
            </button>
          )}
        </div>
      )}

      <div
        style={{
          width: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          position: "relative",
        }}
      >
        <div
          ref={chartRef}
          // style={{
          //   width: `${Math.max(chartData.length * 180, 1000)}px`,
          //   minHeight: "420px",
          // }}
          style={{
            width: `${Math.max(chartData.length * 240, 1200)}px`,
            minHeight: "460px",
          }}
        />
        {localCompanies.length > 6 && (
          <button
            className="btn show_more_finacial"
            onClick={() => setLegendExpanded((prev) => !prev)}
          >
            {legendExpanded
              ? "Show Less"
              : `Show More (${localCompanies.length - 6} more)`}
          </button>
        )}
      </div>
    </div>
  );
};

export default GroupedBarChart;
